var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
System.register([], function(exports, module) {
  "use strict";
  return {
    execute: function() {
      exports("initChaoticEffect", initChaoticEffect);
      const PI_OVER_180 = Math.PI / 180;
      function detectBrowser() {
        return typeof window !== "undefined" && ({}.toString.call(window) === "[object Window]" || {}.toString.call(window) === "[object global]");
      }
      const glob = typeof window !== "undefined" ? window : typeof WorkerGlobalScope !== "undefined" ? self : {};
      const Konva = {
        _global: glob,
        version: "@@version",
        isBrowser: detectBrowser(),
        isUnminified: /param/.test((function(param) {
        }).toString()),
        dblClickWindow: 400,
        getAngle(angle) {
          return Konva.angleDeg ? angle * PI_OVER_180 : angle;
        },
        enableTrace: false,
        pointerEventsEnabled: true,
        autoDrawEnabled: true,
        hitOnDragEnabled: false,
        capturePointerEventsEnabled: false,
        _mouseListenClick: false,
        _touchListenClick: false,
        _pointerListenClick: false,
        _mouseInDblClickWindow: false,
        _touchInDblClickWindow: false,
        _pointerInDblClickWindow: false,
        _mouseDblClickPointerId: null,
        _touchDblClickPointerId: null,
        _pointerDblClickPointerId: null,
        _fixTextRendering: false,
        pixelRatio: typeof window !== "undefined" && window.devicePixelRatio || 1,
        dragDistance: 3,
        angleDeg: true,
        showWarnings: true,
        dragButtons: [0, 1],
        isDragging() {
          var _a;
          return (_a = Konva["DD"]) === null || _a === void 0 ? void 0 : _a.isDragging;
        },
        isTransforming() {
          var _a;
          return (_a = Konva["Transformer"]) === null || _a === void 0 ? void 0 : _a.isTransforming();
        },
        isDragReady() {
          return !!Konva["DD"].node;
        },
        releaseCanvasOnDestroy: true,
        document: glob.document,
        _injectGlobal(Konva2) {
          glob.Konva = Konva2;
        }
      };
      const _registerNode = (NodeClass) => {
        Konva[NodeClass.prototype.getClassName()] = NodeClass;
      };
      Konva._injectGlobal(Konva);
      class Transform {
        constructor(m = [1, 0, 0, 1, 0, 0]) {
          this.dirty = false;
          this.m = m && m.slice() || [1, 0, 0, 1, 0, 0];
        }
        reset() {
          this.m[0] = 1;
          this.m[1] = 0;
          this.m[2] = 0;
          this.m[3] = 1;
          this.m[4] = 0;
          this.m[5] = 0;
        }
        copy() {
          return new Transform(this.m);
        }
        copyInto(tr) {
          tr.m[0] = this.m[0];
          tr.m[1] = this.m[1];
          tr.m[2] = this.m[2];
          tr.m[3] = this.m[3];
          tr.m[4] = this.m[4];
          tr.m[5] = this.m[5];
        }
        point(point) {
          const m = this.m;
          return {
            x: m[0] * point.x + m[2] * point.y + m[4],
            y: m[1] * point.x + m[3] * point.y + m[5]
          };
        }
        translate(x, y) {
          this.m[4] += this.m[0] * x + this.m[2] * y;
          this.m[5] += this.m[1] * x + this.m[3] * y;
          return this;
        }
        scale(sx, sy) {
          this.m[0] *= sx;
          this.m[1] *= sx;
          this.m[2] *= sy;
          this.m[3] *= sy;
          return this;
        }
        rotate(rad) {
          const c = Math.cos(rad);
          const s = Math.sin(rad);
          const m11 = this.m[0] * c + this.m[2] * s;
          const m12 = this.m[1] * c + this.m[3] * s;
          const m21 = this.m[0] * -s + this.m[2] * c;
          const m22 = this.m[1] * -s + this.m[3] * c;
          this.m[0] = m11;
          this.m[1] = m12;
          this.m[2] = m21;
          this.m[3] = m22;
          return this;
        }
        getTranslation() {
          return {
            x: this.m[4],
            y: this.m[5]
          };
        }
        skew(sx, sy) {
          const m11 = this.m[0] + this.m[2] * sy;
          const m12 = this.m[1] + this.m[3] * sy;
          const m21 = this.m[2] + this.m[0] * sx;
          const m22 = this.m[3] + this.m[1] * sx;
          this.m[0] = m11;
          this.m[1] = m12;
          this.m[2] = m21;
          this.m[3] = m22;
          return this;
        }
        multiply(matrix) {
          const m11 = this.m[0] * matrix.m[0] + this.m[2] * matrix.m[1];
          const m12 = this.m[1] * matrix.m[0] + this.m[3] * matrix.m[1];
          const m21 = this.m[0] * matrix.m[2] + this.m[2] * matrix.m[3];
          const m22 = this.m[1] * matrix.m[2] + this.m[3] * matrix.m[3];
          const dx = this.m[0] * matrix.m[4] + this.m[2] * matrix.m[5] + this.m[4];
          const dy = this.m[1] * matrix.m[4] + this.m[3] * matrix.m[5] + this.m[5];
          this.m[0] = m11;
          this.m[1] = m12;
          this.m[2] = m21;
          this.m[3] = m22;
          this.m[4] = dx;
          this.m[5] = dy;
          return this;
        }
        invert() {
          const d = 1 / (this.m[0] * this.m[3] - this.m[1] * this.m[2]);
          const m0 = this.m[3] * d;
          const m1 = -this.m[1] * d;
          const m2 = -this.m[2] * d;
          const m3 = this.m[0] * d;
          const m4 = d * (this.m[2] * this.m[5] - this.m[3] * this.m[4]);
          const m5 = d * (this.m[1] * this.m[4] - this.m[0] * this.m[5]);
          this.m[0] = m0;
          this.m[1] = m1;
          this.m[2] = m2;
          this.m[3] = m3;
          this.m[4] = m4;
          this.m[5] = m5;
          return this;
        }
        getMatrix() {
          return this.m;
        }
        decompose() {
          const a = this.m[0];
          const b = this.m[1];
          const c = this.m[2];
          const d = this.m[3];
          const e = this.m[4];
          const f = this.m[5];
          const delta = a * d - b * c;
          const result = {
            x: e,
            y: f,
            rotation: 0,
            scaleX: 0,
            scaleY: 0,
            skewX: 0,
            skewY: 0
          };
          if (a != 0 || b != 0) {
            const r = Math.sqrt(a * a + b * b);
            result.rotation = b > 0 ? Math.acos(a / r) : -Math.acos(a / r);
            result.scaleX = r;
            result.scaleY = delta / r;
            result.skewX = (a * c + b * d) / delta;
            result.skewY = 0;
          } else if (c != 0 || d != 0) {
            const s = Math.sqrt(c * c + d * d);
            result.rotation = Math.PI / 2 - (d > 0 ? Math.acos(-c / s) : -Math.acos(c / s));
            result.scaleX = delta / s;
            result.scaleY = s;
            result.skewX = 0;
            result.skewY = (a * c + b * d) / delta;
          } else ;
          result.rotation = Util._getRotation(result.rotation);
          return result;
        }
      }
      const OBJECT_ARRAY = "[object Array]", OBJECT_NUMBER = "[object Number]", OBJECT_STRING = "[object String]", OBJECT_BOOLEAN = "[object Boolean]", PI_OVER_DEG180 = Math.PI / 180, DEG180_OVER_PI = 180 / Math.PI, HASH$1 = "#", EMPTY_STRING = "", ZERO = "0", KONVA_WARNING = "Konva warning: ", KONVA_ERROR = "Konva error: ", RGB_PAREN = "rgb(", COLORS = {
        aliceblue: [240, 248, 255],
        antiquewhite: [250, 235, 215],
        aqua: [0, 255, 255],
        aquamarine: [127, 255, 212],
        azure: [240, 255, 255],
        beige: [245, 245, 220],
        bisque: [255, 228, 196],
        black: [0, 0, 0],
        blanchedalmond: [255, 235, 205],
        blue: [0, 0, 255],
        blueviolet: [138, 43, 226],
        brown: [165, 42, 42],
        burlywood: [222, 184, 135],
        cadetblue: [95, 158, 160],
        chartreuse: [127, 255, 0],
        chocolate: [210, 105, 30],
        coral: [255, 127, 80],
        cornflowerblue: [100, 149, 237],
        cornsilk: [255, 248, 220],
        crimson: [220, 20, 60],
        cyan: [0, 255, 255],
        darkblue: [0, 0, 139],
        darkcyan: [0, 139, 139],
        darkgoldenrod: [184, 132, 11],
        darkgray: [169, 169, 169],
        darkgreen: [0, 100, 0],
        darkgrey: [169, 169, 169],
        darkkhaki: [189, 183, 107],
        darkmagenta: [139, 0, 139],
        darkolivegreen: [85, 107, 47],
        darkorange: [255, 140, 0],
        darkorchid: [153, 50, 204],
        darkred: [139, 0, 0],
        darksalmon: [233, 150, 122],
        darkseagreen: [143, 188, 143],
        darkslateblue: [72, 61, 139],
        darkslategray: [47, 79, 79],
        darkslategrey: [47, 79, 79],
        darkturquoise: [0, 206, 209],
        darkviolet: [148, 0, 211],
        deeppink: [255, 20, 147],
        deepskyblue: [0, 191, 255],
        dimgray: [105, 105, 105],
        dimgrey: [105, 105, 105],
        dodgerblue: [30, 144, 255],
        firebrick: [178, 34, 34],
        floralwhite: [255, 255, 240],
        forestgreen: [34, 139, 34],
        fuchsia: [255, 0, 255],
        gainsboro: [220, 220, 220],
        ghostwhite: [248, 248, 255],
        gold: [255, 215, 0],
        goldenrod: [218, 165, 32],
        gray: [128, 128, 128],
        green: [0, 128, 0],
        greenyellow: [173, 255, 47],
        grey: [128, 128, 128],
        honeydew: [240, 255, 240],
        hotpink: [255, 105, 180],
        indianred: [205, 92, 92],
        indigo: [75, 0, 130],
        ivory: [255, 255, 240],
        khaki: [240, 230, 140],
        lavender: [230, 230, 250],
        lavenderblush: [255, 240, 245],
        lawngreen: [124, 252, 0],
        lemonchiffon: [255, 250, 205],
        lightblue: [173, 216, 230],
        lightcoral: [240, 128, 128],
        lightcyan: [224, 255, 255],
        lightgoldenrodyellow: [250, 250, 210],
        lightgray: [211, 211, 211],
        lightgreen: [144, 238, 144],
        lightgrey: [211, 211, 211],
        lightpink: [255, 182, 193],
        lightsalmon: [255, 160, 122],
        lightseagreen: [32, 178, 170],
        lightskyblue: [135, 206, 250],
        lightslategray: [119, 136, 153],
        lightslategrey: [119, 136, 153],
        lightsteelblue: [176, 196, 222],
        lightyellow: [255, 255, 224],
        lime: [0, 255, 0],
        limegreen: [50, 205, 50],
        linen: [250, 240, 230],
        magenta: [255, 0, 255],
        maroon: [128, 0, 0],
        mediumaquamarine: [102, 205, 170],
        mediumblue: [0, 0, 205],
        mediumorchid: [186, 85, 211],
        mediumpurple: [147, 112, 219],
        mediumseagreen: [60, 179, 113],
        mediumslateblue: [123, 104, 238],
        mediumspringgreen: [0, 250, 154],
        mediumturquoise: [72, 209, 204],
        mediumvioletred: [199, 21, 133],
        midnightblue: [25, 25, 112],
        mintcream: [245, 255, 250],
        mistyrose: [255, 228, 225],
        moccasin: [255, 228, 181],
        navajowhite: [255, 222, 173],
        navy: [0, 0, 128],
        oldlace: [253, 245, 230],
        olive: [128, 128, 0],
        olivedrab: [107, 142, 35],
        orange: [255, 165, 0],
        orangered: [255, 69, 0],
        orchid: [218, 112, 214],
        palegoldenrod: [238, 232, 170],
        palegreen: [152, 251, 152],
        paleturquoise: [175, 238, 238],
        palevioletred: [219, 112, 147],
        papayawhip: [255, 239, 213],
        peachpuff: [255, 218, 185],
        peru: [205, 133, 63],
        pink: [255, 192, 203],
        plum: [221, 160, 203],
        powderblue: [176, 224, 230],
        purple: [128, 0, 128],
        rebeccapurple: [102, 51, 153],
        red: [255, 0, 0],
        rosybrown: [188, 143, 143],
        royalblue: [65, 105, 225],
        saddlebrown: [139, 69, 19],
        salmon: [250, 128, 114],
        sandybrown: [244, 164, 96],
        seagreen: [46, 139, 87],
        seashell: [255, 245, 238],
        sienna: [160, 82, 45],
        silver: [192, 192, 192],
        skyblue: [135, 206, 235],
        slateblue: [106, 90, 205],
        slategray: [119, 128, 144],
        slategrey: [119, 128, 144],
        snow: [255, 255, 250],
        springgreen: [0, 255, 127],
        steelblue: [70, 130, 180],
        tan: [210, 180, 140],
        teal: [0, 128, 128],
        thistle: [216, 191, 216],
        transparent: [255, 255, 255, 0],
        tomato: [255, 99, 71],
        turquoise: [64, 224, 208],
        violet: [238, 130, 238],
        wheat: [245, 222, 179],
        white: [255, 255, 255],
        whitesmoke: [245, 245, 245],
        yellow: [255, 255, 0],
        yellowgreen: [154, 205, 5]
      }, RGB_REGEX = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
      let animQueue = [];
      const req = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame || function(f) {
        setTimeout(f, 60);
      };
      const Util = {
        _isElement(obj) {
          return !!(obj && obj.nodeType == 1);
        },
        _isFunction(obj) {
          return !!(obj && obj.constructor && obj.call && obj.apply);
        },
        _isPlainObject(obj) {
          return !!obj && obj.constructor === Object;
        },
        _isArray(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_ARRAY;
        },
        _isNumber(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_NUMBER && !isNaN(obj) && isFinite(obj);
        },
        _isString(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_STRING;
        },
        _isBoolean(obj) {
          return Object.prototype.toString.call(obj) === OBJECT_BOOLEAN;
        },
        isObject(val) {
          return val instanceof Object;
        },
        isValidSelector(selector) {
          if (typeof selector !== "string") {
            return false;
          }
          const firstChar = selector[0];
          return firstChar === "#" || firstChar === "." || firstChar === firstChar.toUpperCase();
        },
        _sign(number) {
          if (number === 0) {
            return 1;
          }
          if (number > 0) {
            return 1;
          } else {
            return -1;
          }
        },
        requestAnimFrame(callback) {
          animQueue.push(callback);
          if (animQueue.length === 1) {
            req(function() {
              const queue = animQueue;
              animQueue = [];
              queue.forEach(function(cb) {
                cb();
              });
            });
          }
        },
        createCanvasElement() {
          const canvas = document.createElement("canvas");
          try {
            canvas.style = canvas.style || {};
          } catch (e) {
          }
          return canvas;
        },
        createImageElement() {
          return document.createElement("img");
        },
        _isInDocument(el) {
          while (el = el.parentNode) {
            if (el == document) {
              return true;
            }
          }
          return false;
        },
        _urlToImage(url, callback) {
          const imageObj = Util.createImageElement();
          imageObj.onload = function() {
            callback(imageObj);
          };
          imageObj.src = url;
        },
        _rgbToHex(r, g, b) {
          return ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
        },
        _hexToRgb(hex) {
          hex = hex.replace(HASH$1, EMPTY_STRING);
          const bigint = parseInt(hex, 16);
          return {
            r: bigint >> 16 & 255,
            g: bigint >> 8 & 255,
            b: bigint & 255
          };
        },
        getRandomColor() {
          let randColor = (Math.random() * 16777215 << 0).toString(16);
          while (randColor.length < 6) {
            randColor = ZERO + randColor;
          }
          return HASH$1 + randColor;
        },
        getRGB(color) {
          let rgb;
          if (color in COLORS) {
            rgb = COLORS[color];
            return {
              r: rgb[0],
              g: rgb[1],
              b: rgb[2]
            };
          } else if (color[0] === HASH$1) {
            return this._hexToRgb(color.substring(1));
          } else if (color.substr(0, 4) === RGB_PAREN) {
            rgb = RGB_REGEX.exec(color.replace(/ /g, ""));
            return {
              r: parseInt(rgb[1], 10),
              g: parseInt(rgb[2], 10),
              b: parseInt(rgb[3], 10)
            };
          } else {
            return {
              r: 0,
              g: 0,
              b: 0
            };
          }
        },
        colorToRGBA(str) {
          str = str || "black";
          return Util._namedColorToRBA(str) || Util._hex3ColorToRGBA(str) || Util._hex4ColorToRGBA(str) || Util._hex6ColorToRGBA(str) || Util._hex8ColorToRGBA(str) || Util._rgbColorToRGBA(str) || Util._rgbaColorToRGBA(str) || Util._hslColorToRGBA(str);
        },
        _namedColorToRBA(str) {
          const c = COLORS[str.toLowerCase()];
          if (!c) {
            return null;
          }
          return {
            r: c[0],
            g: c[1],
            b: c[2],
            a: 1
          };
        },
        _rgbColorToRGBA(str) {
          if (str.indexOf("rgb(") === 0) {
            str = str.match(/rgb\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map(Number);
            return {
              r: parts[0],
              g: parts[1],
              b: parts[2],
              a: 1
            };
          }
        },
        _rgbaColorToRGBA(str) {
          if (str.indexOf("rgba(") === 0) {
            str = str.match(/rgba\(([^)]+)\)/)[1];
            const parts = str.split(/ *, */).map((n, index) => {
              if (n.slice(-1) === "%") {
                return index === 3 ? parseInt(n) / 100 : parseInt(n) / 100 * 255;
              }
              return Number(n);
            });
            return {
              r: parts[0],
              g: parts[1],
              b: parts[2],
              a: parts[3]
            };
          }
        },
        _hex8ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 9) {
            return {
              r: parseInt(str.slice(1, 3), 16),
              g: parseInt(str.slice(3, 5), 16),
              b: parseInt(str.slice(5, 7), 16),
              a: parseInt(str.slice(7, 9), 16) / 255
            };
          }
        },
        _hex6ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 7) {
            return {
              r: parseInt(str.slice(1, 3), 16),
              g: parseInt(str.slice(3, 5), 16),
              b: parseInt(str.slice(5, 7), 16),
              a: 1
            };
          }
        },
        _hex4ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 5) {
            return {
              r: parseInt(str[1] + str[1], 16),
              g: parseInt(str[2] + str[2], 16),
              b: parseInt(str[3] + str[3], 16),
              a: parseInt(str[4] + str[4], 16) / 255
            };
          }
        },
        _hex3ColorToRGBA(str) {
          if (str[0] === "#" && str.length === 4) {
            return {
              r: parseInt(str[1] + str[1], 16),
              g: parseInt(str[2] + str[2], 16),
              b: parseInt(str[3] + str[3], 16),
              a: 1
            };
          }
        },
        _hslColorToRGBA(str) {
          if (/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.test(str)) {
            const [_, ...hsl] = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(str);
            const h = Number(hsl[0]) / 360;
            const s = Number(hsl[1]) / 100;
            const l = Number(hsl[2]) / 100;
            let t2;
            let t3;
            let val;
            if (s === 0) {
              val = l * 255;
              return {
                r: Math.round(val),
                g: Math.round(val),
                b: Math.round(val),
                a: 1
              };
            }
            if (l < 0.5) {
              t2 = l * (1 + s);
            } else {
              t2 = l + s - l * s;
            }
            const t1 = 2 * l - t2;
            const rgb = [0, 0, 0];
            for (let i = 0; i < 3; i++) {
              t3 = h + 1 / 3 * -(i - 1);
              if (t3 < 0) {
                t3++;
              }
              if (t3 > 1) {
                t3--;
              }
              if (6 * t3 < 1) {
                val = t1 + (t2 - t1) * 6 * t3;
              } else if (2 * t3 < 1) {
                val = t2;
              } else if (3 * t3 < 2) {
                val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
              } else {
                val = t1;
              }
              rgb[i] = val * 255;
            }
            return {
              r: Math.round(rgb[0]),
              g: Math.round(rgb[1]),
              b: Math.round(rgb[2]),
              a: 1
            };
          }
        },
        haveIntersection(r1, r2) {
          return !(r2.x > r1.x + r1.width || r2.x + r2.width < r1.x || r2.y > r1.y + r1.height || r2.y + r2.height < r1.y);
        },
        cloneObject(obj) {
          const retObj = {};
          for (const key in obj) {
            if (this._isPlainObject(obj[key])) {
              retObj[key] = this.cloneObject(obj[key]);
            } else if (this._isArray(obj[key])) {
              retObj[key] = this.cloneArray(obj[key]);
            } else {
              retObj[key] = obj[key];
            }
          }
          return retObj;
        },
        cloneArray(arr) {
          return arr.slice(0);
        },
        degToRad(deg) {
          return deg * PI_OVER_DEG180;
        },
        radToDeg(rad) {
          return rad * DEG180_OVER_PI;
        },
        _degToRad(deg) {
          Util.warn("Util._degToRad is removed. Please use public Util.degToRad instead.");
          return Util.degToRad(deg);
        },
        _radToDeg(rad) {
          Util.warn("Util._radToDeg is removed. Please use public Util.radToDeg instead.");
          return Util.radToDeg(rad);
        },
        _getRotation(radians) {
          return Konva.angleDeg ? Util.radToDeg(radians) : radians;
        },
        _capitalize(str) {
          return str.charAt(0).toUpperCase() + str.slice(1);
        },
        throw(str) {
          throw new Error(KONVA_ERROR + str);
        },
        error(str) {
          console.error(KONVA_ERROR + str);
        },
        warn(str) {
          if (!Konva.showWarnings) {
            return;
          }
          console.warn(KONVA_WARNING + str);
        },
        each(obj, func) {
          for (const key in obj) {
            func(key, obj[key]);
          }
        },
        _inRange(val, left, right) {
          return left <= val && val < right;
        },
        _getProjectionToSegment(x1, y1, x2, y2, x3, y3) {
          let x, y, dist;
          const pd2 = (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
          if (pd2 == 0) {
            x = x1;
            y = y1;
            dist = (x3 - x2) * (x3 - x2) + (y3 - y2) * (y3 - y2);
          } else {
            const u = ((x3 - x1) * (x2 - x1) + (y3 - y1) * (y2 - y1)) / pd2;
            if (u < 0) {
              x = x1;
              y = y1;
              dist = (x1 - x3) * (x1 - x3) + (y1 - y3) * (y1 - y3);
            } else if (u > 1) {
              x = x2;
              y = y2;
              dist = (x2 - x3) * (x2 - x3) + (y2 - y3) * (y2 - y3);
            } else {
              x = x1 + u * (x2 - x1);
              y = y1 + u * (y2 - y1);
              dist = (x - x3) * (x - x3) + (y - y3) * (y - y3);
            }
          }
          return [x, y, dist];
        },
        _getProjectionToLine(pt, line, isClosed) {
          const pc = Util.cloneObject(pt);
          let dist = Number.MAX_VALUE;
          line.forEach(function(p1, i) {
            if (!isClosed && i === line.length - 1) {
              return;
            }
            const p2 = line[(i + 1) % line.length];
            const proj = Util._getProjectionToSegment(p1.x, p1.y, p2.x, p2.y, pt.x, pt.y);
            const px = proj[0], py = proj[1], pdist = proj[2];
            if (pdist < dist) {
              pc.x = px;
              pc.y = py;
              dist = pdist;
            }
          });
          return pc;
        },
        _prepareArrayForTween(startArray, endArray, isClosed) {
          const start = [], end = [];
          if (startArray.length > endArray.length) {
            const temp = endArray;
            endArray = startArray;
            startArray = temp;
          }
          for (let n = 0; n < startArray.length; n += 2) {
            start.push({
              x: startArray[n],
              y: startArray[n + 1]
            });
          }
          for (let n = 0; n < endArray.length; n += 2) {
            end.push({
              x: endArray[n],
              y: endArray[n + 1]
            });
          }
          const newStart = [];
          end.forEach(function(point) {
            const pr = Util._getProjectionToLine(point, start, isClosed);
            newStart.push(pr.x);
            newStart.push(pr.y);
          });
          return newStart;
        },
        _prepareToStringify(obj) {
          let desc;
          obj.visitedByCircularReferenceRemoval = true;
          for (const key in obj) {
            if (!(obj.hasOwnProperty(key) && obj[key] && typeof obj[key] == "object")) {
              continue;
            }
            desc = Object.getOwnPropertyDescriptor(obj, key);
            if (obj[key].visitedByCircularReferenceRemoval || Util._isElement(obj[key])) {
              if (desc.configurable) {
                delete obj[key];
              } else {
                return null;
              }
            } else if (Util._prepareToStringify(obj[key]) === null) {
              if (desc.configurable) {
                delete obj[key];
              } else {
                return null;
              }
            }
          }
          delete obj.visitedByCircularReferenceRemoval;
          return obj;
        },
        _assign(target, source) {
          for (const key in source) {
            target[key] = source[key];
          }
          return target;
        },
        _getFirstPointerId(evt) {
          if (!evt.touches) {
            return evt.pointerId || 999;
          } else {
            return evt.changedTouches[0].identifier;
          }
        },
        releaseCanvas(...canvases) {
          if (!Konva.releaseCanvasOnDestroy)
            return;
          canvases.forEach((c) => {
            c.width = 0;
            c.height = 0;
          });
        },
        drawRoundedRectPath(context, width, height, cornerRadius) {
          let topLeft = 0;
          let topRight = 0;
          let bottomLeft = 0;
          let bottomRight = 0;
          if (typeof cornerRadius === "number") {
            topLeft = topRight = bottomLeft = bottomRight = Math.min(cornerRadius, width / 2, height / 2);
          } else {
            topLeft = Math.min(cornerRadius[0] || 0, width / 2, height / 2);
            topRight = Math.min(cornerRadius[1] || 0, width / 2, height / 2);
            bottomRight = Math.min(cornerRadius[2] || 0, width / 2, height / 2);
            bottomLeft = Math.min(cornerRadius[3] || 0, width / 2, height / 2);
          }
          context.moveTo(topLeft, 0);
          context.lineTo(width - topRight, 0);
          context.arc(width - topRight, topRight, topRight, Math.PI * 3 / 2, 0, false);
          context.lineTo(width, height - bottomRight);
          context.arc(width - bottomRight, height - bottomRight, bottomRight, 0, Math.PI / 2, false);
          context.lineTo(bottomLeft, height);
          context.arc(bottomLeft, height - bottomLeft, bottomLeft, Math.PI / 2, Math.PI, false);
          context.lineTo(0, topLeft);
          context.arc(topLeft, topLeft, topLeft, Math.PI, Math.PI * 3 / 2, false);
        }
      };
      function _formatValue(val) {
        if (Util._isString(val)) {
          return '"' + val + '"';
        }
        if (Object.prototype.toString.call(val) === "[object Number]") {
          return val;
        }
        if (Util._isBoolean(val)) {
          return val;
        }
        return Object.prototype.toString.call(val);
      }
      function getNumberValidator() {
        if (Konva.isUnminified) {
          return function(val, attr) {
            if (!Util._isNumber(val)) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number.');
            }
            return val;
          };
        }
      }
      function getNumberOrArrayOfNumbersValidator(noOfElements) {
        if (Konva.isUnminified) {
          return function(val, attr) {
            let isNumber = Util._isNumber(val);
            let isValidArray = Util._isArray(val) && val.length == noOfElements;
            if (!isNumber && !isValidArray) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or Array<number>(' + noOfElements + ")");
            }
            return val;
          };
        }
      }
      function getNumberOrAutoValidator() {
        if (Konva.isUnminified) {
          return function(val, attr) {
            const isNumber = Util._isNumber(val);
            const isAuto = val === "auto";
            if (!(isNumber || isAuto)) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a number or "auto".');
            }
            return val;
          };
        }
      }
      function getStringValidator() {
        if (Konva.isUnminified) {
          return function(val, attr) {
            if (!Util._isString(val)) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string.');
            }
            return val;
          };
        }
      }
      function getStringOrGradientValidator() {
        if (Konva.isUnminified) {
          return function(val, attr) {
            const isString = Util._isString(val);
            const isGradient = Object.prototype.toString.call(val) === "[object CanvasGradient]" || val && val["addColorStop"];
            if (!(isString || isGradient)) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a string or a native gradient.');
            }
            return val;
          };
        }
      }
      function getBooleanValidator() {
        if (Konva.isUnminified) {
          return function(val, attr) {
            const isBool = val === true || val === false;
            if (!isBool) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be a boolean.');
            }
            return val;
          };
        }
      }
      function getComponentValidator(components) {
        if (Konva.isUnminified) {
          return function(val, attr) {
            if (val === void 0 || val === null) {
              return val;
            }
            if (!Util.isObject(val)) {
              Util.warn(_formatValue(val) + ' is a not valid value for "' + attr + '" attribute. The value should be an object with properties ' + components);
            }
            return val;
          };
        }
      }
      const GET = "get";
      const SET$1 = "set";
      const Factory = {
        addGetterSetter(constructor, attr, def, validator, after) {
          Factory.addGetter(constructor, attr, def);
          Factory.addSetter(constructor, attr, validator, after);
          Factory.addOverloadedGetterSetter(constructor, attr);
        },
        addGetter(constructor, attr, def) {
          const method = GET + Util._capitalize(attr);
          constructor.prototype[method] = constructor.prototype[method] || function() {
            const val = this.attrs[attr];
            return val === void 0 ? def : val;
          };
        },
        addSetter(constructor, attr, validator, after) {
          const method = SET$1 + Util._capitalize(attr);
          if (!constructor.prototype[method]) {
            Factory.overWriteSetter(constructor, attr, validator, after);
          }
        },
        overWriteSetter(constructor, attr, validator, after) {
          const method = SET$1 + Util._capitalize(attr);
          constructor.prototype[method] = function(val) {
            if (validator && val !== void 0 && val !== null) {
              val = validator.call(this, val, attr);
            }
            this._setAttr(attr, val);
            if (after) {
              after.call(this);
            }
            return this;
          };
        },
        addComponentsGetterSetter(constructor, attr, components, validator, after) {
          const len = components.length, capitalize = Util._capitalize, getter = GET + capitalize(attr), setter = SET$1 + capitalize(attr);
          constructor.prototype[getter] = function() {
            const ret = {};
            for (let n = 0; n < len; n++) {
              const component = components[n];
              ret[component] = this.getAttr(attr + capitalize(component));
            }
            return ret;
          };
          const basicValidator = getComponentValidator(components);
          constructor.prototype[setter] = function(val) {
            const oldVal = this.attrs[attr];
            if (validator) {
              val = validator.call(this, val, attr);
            }
            if (basicValidator) {
              basicValidator.call(this, val, attr);
            }
            for (const key in val) {
              if (!val.hasOwnProperty(key)) {
                continue;
              }
              this._setAttr(attr + capitalize(key), val[key]);
            }
            if (!val) {
              components.forEach((component) => {
                this._setAttr(attr + capitalize(component), void 0);
              });
            }
            this._fireChangeEvent(attr, oldVal, val);
            if (after) {
              after.call(this);
            }
            return this;
          };
          Factory.addOverloadedGetterSetter(constructor, attr);
        },
        addOverloadedGetterSetter(constructor, attr) {
          const capitalizedAttr = Util._capitalize(attr), setter = SET$1 + capitalizedAttr, getter = GET + capitalizedAttr;
          constructor.prototype[attr] = function() {
            if (arguments.length) {
              this[setter](arguments[0]);
              return this;
            }
            return this[getter]();
          };
        },
        addDeprecatedGetterSetter(constructor, attr, def, validator) {
          Util.error("Adding deprecated " + attr);
          const method = GET + Util._capitalize(attr);
          const message = attr + " property is deprecated and will be removed soon. Look at Konva change log for more information.";
          constructor.prototype[method] = function() {
            Util.error(message);
            const val = this.attrs[attr];
            return val === void 0 ? def : val;
          };
          Factory.addSetter(constructor, attr, validator, function() {
            Util.error(message);
          });
          Factory.addOverloadedGetterSetter(constructor, attr);
        },
        backCompat(constructor, methods) {
          Util.each(methods, function(oldMethodName, newMethodName) {
            const method = constructor.prototype[newMethodName];
            const oldGetter = GET + Util._capitalize(oldMethodName);
            const oldSetter = SET$1 + Util._capitalize(oldMethodName);
            function deprecated() {
              method.apply(this, arguments);
              Util.error('"' + oldMethodName + '" method is deprecated and will be removed soon. Use ""' + newMethodName + '" instead.');
            }
            constructor.prototype[oldMethodName] = deprecated;
            constructor.prototype[oldGetter] = deprecated;
            constructor.prototype[oldSetter] = deprecated;
          });
        },
        afterSetFilter() {
          this._filterUpToDate = false;
        }
      };
      function simplifyArray(arr) {
        const retArr = [], len = arr.length, util = Util;
        for (let n = 0; n < len; n++) {
          let val = arr[n];
          if (util._isNumber(val)) {
            val = Math.round(val * 1e3) / 1e3;
          } else if (!util._isString(val)) {
            val = val + "";
          }
          retArr.push(val);
        }
        return retArr;
      }
      const COMMA = ",", OPEN_PAREN = "(", CLOSE_PAREN = ")", OPEN_PAREN_BRACKET = "([", CLOSE_BRACKET_PAREN = "])", SEMICOLON = ";", DOUBLE_PAREN = "()", EQUALS = "=", CONTEXT_METHODS = [
        "arc",
        "arcTo",
        "beginPath",
        "bezierCurveTo",
        "clearRect",
        "clip",
        "closePath",
        "createLinearGradient",
        "createPattern",
        "createRadialGradient",
        "drawImage",
        "ellipse",
        "fill",
        "fillText",
        "getImageData",
        "createImageData",
        "lineTo",
        "moveTo",
        "putImageData",
        "quadraticCurveTo",
        "rect",
        "roundRect",
        "restore",
        "rotate",
        "save",
        "scale",
        "setLineDash",
        "setTransform",
        "stroke",
        "strokeText",
        "transform",
        "translate"
      ];
      const CONTEXT_PROPERTIES = [
        "fillStyle",
        "strokeStyle",
        "shadowColor",
        "shadowBlur",
        "shadowOffsetX",
        "shadowOffsetY",
        "letterSpacing",
        "lineCap",
        "lineDashOffset",
        "lineJoin",
        "lineWidth",
        "miterLimit",
        "direction",
        "font",
        "textAlign",
        "textBaseline",
        "globalAlpha",
        "globalCompositeOperation",
        "imageSmoothingEnabled"
      ];
      const traceArrMax = 100;
      class Context {
        constructor(canvas) {
          this.canvas = canvas;
          if (Konva.enableTrace) {
            this.traceArr = [];
            this._enableTrace();
          }
        }
        fillShape(shape) {
          if (shape.fillEnabled()) {
            this._fill(shape);
          }
        }
        _fill(shape) {
        }
        strokeShape(shape) {
          if (shape.hasStroke()) {
            this._stroke(shape);
          }
        }
        _stroke(shape) {
        }
        fillStrokeShape(shape) {
          if (shape.attrs.fillAfterStrokeEnabled) {
            this.strokeShape(shape);
            this.fillShape(shape);
          } else {
            this.fillShape(shape);
            this.strokeShape(shape);
          }
        }
        getTrace(relaxed, rounded) {
          let traceArr = this.traceArr, len = traceArr.length, str = "", n, trace, method, args;
          for (n = 0; n < len; n++) {
            trace = traceArr[n];
            method = trace.method;
            if (method) {
              args = trace.args;
              str += method;
              if (relaxed) {
                str += DOUBLE_PAREN;
              } else {
                if (Util._isArray(args[0])) {
                  str += OPEN_PAREN_BRACKET + args.join(COMMA) + CLOSE_BRACKET_PAREN;
                } else {
                  if (rounded) {
                    args = args.map((a) => typeof a === "number" ? Math.floor(a) : a);
                  }
                  str += OPEN_PAREN + args.join(COMMA) + CLOSE_PAREN;
                }
              }
            } else {
              str += trace.property;
              if (!relaxed) {
                str += EQUALS + trace.val;
              }
            }
            str += SEMICOLON;
          }
          return str;
        }
        clearTrace() {
          this.traceArr = [];
        }
        _trace(str) {
          let traceArr = this.traceArr, len;
          traceArr.push(str);
          len = traceArr.length;
          if (len >= traceArrMax) {
            traceArr.shift();
          }
        }
        reset() {
          const pixelRatio = this.getCanvas().getPixelRatio();
          this.setTransform(1 * pixelRatio, 0, 0, 1 * pixelRatio, 0, 0);
        }
        getCanvas() {
          return this.canvas;
        }
        clear(bounds) {
          const canvas = this.getCanvas();
          if (bounds) {
            this.clearRect(bounds.x || 0, bounds.y || 0, bounds.width || 0, bounds.height || 0);
          } else {
            this.clearRect(0, 0, canvas.getWidth() / canvas.pixelRatio, canvas.getHeight() / canvas.pixelRatio);
          }
        }
        _applyLineCap(shape) {
          const lineCap = shape.attrs.lineCap;
          if (lineCap) {
            this.setAttr("lineCap", lineCap);
          }
        }
        _applyOpacity(shape) {
          const absOpacity = shape.getAbsoluteOpacity();
          if (absOpacity !== 1) {
            this.setAttr("globalAlpha", absOpacity);
          }
        }
        _applyLineJoin(shape) {
          const lineJoin = shape.attrs.lineJoin;
          if (lineJoin) {
            this.setAttr("lineJoin", lineJoin);
          }
        }
        setAttr(attr, val) {
          this._context[attr] = val;
        }
        arc(x, y, radius, startAngle, endAngle, counterClockwise) {
          this._context.arc(x, y, radius, startAngle, endAngle, counterClockwise);
        }
        arcTo(x1, y1, x2, y2, radius) {
          this._context.arcTo(x1, y1, x2, y2, radius);
        }
        beginPath() {
          this._context.beginPath();
        }
        bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y) {
          this._context.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        }
        clearRect(x, y, width, height) {
          this._context.clearRect(x, y, width, height);
        }
        clip(...args) {
          this._context.clip.apply(this._context, args);
        }
        closePath() {
          this._context.closePath();
        }
        createImageData(width, height) {
          const a = arguments;
          if (a.length === 2) {
            return this._context.createImageData(width, height);
          } else if (a.length === 1) {
            return this._context.createImageData(width);
          }
        }
        createLinearGradient(x0, y0, x1, y1) {
          return this._context.createLinearGradient(x0, y0, x1, y1);
        }
        createPattern(image, repetition) {
          return this._context.createPattern(image, repetition);
        }
        createRadialGradient(x0, y0, r0, x1, y1, r1) {
          return this._context.createRadialGradient(x0, y0, r0, x1, y1, r1);
        }
        drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
          const a = arguments, _context = this._context;
          if (a.length === 3) {
            _context.drawImage(image, sx, sy);
          } else if (a.length === 5) {
            _context.drawImage(image, sx, sy, sWidth, sHeight);
          } else if (a.length === 9) {
            _context.drawImage(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
          }
        }
        ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise) {
          this._context.ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle, counterclockwise);
        }
        isPointInPath(x, y, path, fillRule) {
          if (path) {
            return this._context.isPointInPath(path, x, y, fillRule);
          }
          return this._context.isPointInPath(x, y, fillRule);
        }
        fill(...args) {
          this._context.fill.apply(this._context, args);
        }
        fillRect(x, y, width, height) {
          this._context.fillRect(x, y, width, height);
        }
        strokeRect(x, y, width, height) {
          this._context.strokeRect(x, y, width, height);
        }
        fillText(text, x, y, maxWidth) {
          if (maxWidth) {
            this._context.fillText(text, x, y, maxWidth);
          } else {
            this._context.fillText(text, x, y);
          }
        }
        measureText(text) {
          return this._context.measureText(text);
        }
        getImageData(sx, sy, sw, sh) {
          return this._context.getImageData(sx, sy, sw, sh);
        }
        lineTo(x, y) {
          this._context.lineTo(x, y);
        }
        moveTo(x, y) {
          this._context.moveTo(x, y);
        }
        rect(x, y, width, height) {
          this._context.rect(x, y, width, height);
        }
        roundRect(x, y, width, height, radii) {
          this._context.roundRect(x, y, width, height, radii);
        }
        putImageData(imageData, dx, dy) {
          this._context.putImageData(imageData, dx, dy);
        }
        quadraticCurveTo(cpx, cpy, x, y) {
          this._context.quadraticCurveTo(cpx, cpy, x, y);
        }
        restore() {
          this._context.restore();
        }
        rotate(angle) {
          this._context.rotate(angle);
        }
        save() {
          this._context.save();
        }
        scale(x, y) {
          this._context.scale(x, y);
        }
        setLineDash(segments) {
          if (this._context.setLineDash) {
            this._context.setLineDash(segments);
          } else if ("mozDash" in this._context) {
            this._context["mozDash"] = segments;
          } else if ("webkitLineDash" in this._context) {
            this._context["webkitLineDash"] = segments;
          }
        }
        getLineDash() {
          return this._context.getLineDash();
        }
        setTransform(a, b, c, d, e, f) {
          this._context.setTransform(a, b, c, d, e, f);
        }
        stroke(path2d) {
          if (path2d) {
            this._context.stroke(path2d);
          } else {
            this._context.stroke();
          }
        }
        strokeText(text, x, y, maxWidth) {
          this._context.strokeText(text, x, y, maxWidth);
        }
        transform(a, b, c, d, e, f) {
          this._context.transform(a, b, c, d, e, f);
        }
        translate(x, y) {
          this._context.translate(x, y);
        }
        _enableTrace() {
          let that = this, len = CONTEXT_METHODS.length, origSetter = this.setAttr, n, args;
          const func = function(methodName) {
            let origMethod = that[methodName], ret;
            that[methodName] = function() {
              args = simplifyArray(Array.prototype.slice.call(arguments, 0));
              ret = origMethod.apply(that, arguments);
              that._trace({
                method: methodName,
                args
              });
              return ret;
            };
          };
          for (n = 0; n < len; n++) {
            func(CONTEXT_METHODS[n]);
          }
          that.setAttr = function() {
            origSetter.apply(that, arguments);
            const prop = arguments[0];
            let val = arguments[1];
            if (prop === "shadowOffsetX" || prop === "shadowOffsetY" || prop === "shadowBlur") {
              val = val / this.canvas.getPixelRatio();
            }
            that._trace({
              property: prop,
              val
            });
          };
        }
        _applyGlobalCompositeOperation(node) {
          const op = node.attrs.globalCompositeOperation;
          const def = !op || op === "source-over";
          if (!def) {
            this.setAttr("globalCompositeOperation", op);
          }
        }
      }
      CONTEXT_PROPERTIES.forEach(function(prop) {
        Object.defineProperty(Context.prototype, prop, {
          get() {
            return this._context[prop];
          },
          set(val) {
            this._context[prop] = val;
          }
        });
      });
      class SceneContext extends Context {
        constructor(canvas, { willReadFrequently = false } = {}) {
          super(canvas);
          this._context = canvas._canvas.getContext("2d", {
            willReadFrequently
          });
        }
        _fillColor(shape) {
          const fill = shape.fill();
          this.setAttr("fillStyle", fill);
          shape._fillFunc(this);
        }
        _fillPattern(shape) {
          this.setAttr("fillStyle", shape._getFillPattern());
          shape._fillFunc(this);
        }
        _fillLinearGradient(shape) {
          const grd = shape._getLinearGradient();
          if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
          }
        }
        _fillRadialGradient(shape) {
          const grd = shape._getRadialGradient();
          if (grd) {
            this.setAttr("fillStyle", grd);
            shape._fillFunc(this);
          }
        }
        _fill(shape) {
          const hasColor = shape.fill(), fillPriority = shape.getFillPriority();
          if (hasColor && fillPriority === "color") {
            this._fillColor(shape);
            return;
          }
          const hasPattern = shape.getFillPatternImage();
          if (hasPattern && fillPriority === "pattern") {
            this._fillPattern(shape);
            return;
          }
          const hasLinearGradient = shape.getFillLinearGradientColorStops();
          if (hasLinearGradient && fillPriority === "linear-gradient") {
            this._fillLinearGradient(shape);
            return;
          }
          const hasRadialGradient = shape.getFillRadialGradientColorStops();
          if (hasRadialGradient && fillPriority === "radial-gradient") {
            this._fillRadialGradient(shape);
            return;
          }
          if (hasColor) {
            this._fillColor(shape);
          } else if (hasPattern) {
            this._fillPattern(shape);
          } else if (hasLinearGradient) {
            this._fillLinearGradient(shape);
          } else if (hasRadialGradient) {
            this._fillRadialGradient(shape);
          }
        }
        _strokeLinearGradient(shape) {
          const start = shape.getStrokeLinearGradientStartPoint(), end = shape.getStrokeLinearGradientEndPoint(), colorStops = shape.getStrokeLinearGradientColorStops(), grd = this.createLinearGradient(start.x, start.y, end.x, end.y);
          if (colorStops) {
            for (let n = 0; n < colorStops.length; n += 2) {
              grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            this.setAttr("strokeStyle", grd);
          }
        }
        _stroke(shape) {
          const dash = shape.dash(), strokeScaleEnabled = shape.getStrokeScaleEnabled();
          if (shape.hasStroke()) {
            if (!strokeScaleEnabled) {
              this.save();
              const pixelRatio = this.getCanvas().getPixelRatio();
              this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            if (dash && shape.dashEnabled()) {
              this.setLineDash(dash);
              this.setAttr("lineDashOffset", shape.dashOffset());
            }
            this.setAttr("lineWidth", shape.strokeWidth());
            if (!shape.getShadowForStrokeEnabled()) {
              this.setAttr("shadowColor", "rgba(0,0,0,0)");
            }
            const hasLinearGradient = shape.getStrokeLinearGradientColorStops();
            if (hasLinearGradient) {
              this._strokeLinearGradient(shape);
            } else {
              this.setAttr("strokeStyle", shape.stroke());
            }
            shape._strokeFunc(this);
            if (!strokeScaleEnabled) {
              this.restore();
            }
          }
        }
        _applyShadow(shape) {
          var _a, _b, _c;
          const color = (_a = shape.getShadowRGBA()) !== null && _a !== void 0 ? _a : "black", blur = (_b = shape.getShadowBlur()) !== null && _b !== void 0 ? _b : 5, offset = (_c = shape.getShadowOffset()) !== null && _c !== void 0 ? _c : {
            x: 0,
            y: 0
          }, scale = shape.getAbsoluteScale(), ratio = this.canvas.getPixelRatio(), scaleX = scale.x * ratio, scaleY = scale.y * ratio;
          this.setAttr("shadowColor", color);
          this.setAttr("shadowBlur", blur * Math.min(Math.abs(scaleX), Math.abs(scaleY)));
          this.setAttr("shadowOffsetX", offset.x * scaleX);
          this.setAttr("shadowOffsetY", offset.y * scaleY);
        }
      }
      class HitContext extends Context {
        constructor(canvas) {
          super(canvas);
          this._context = canvas._canvas.getContext("2d", {
            willReadFrequently: true
          });
        }
        _fill(shape) {
          this.save();
          this.setAttr("fillStyle", shape.colorKey);
          shape._fillFuncHit(this);
          this.restore();
        }
        strokeShape(shape) {
          if (shape.hasHitStroke()) {
            this._stroke(shape);
          }
        }
        _stroke(shape) {
          if (shape.hasHitStroke()) {
            const strokeScaleEnabled = shape.getStrokeScaleEnabled();
            if (!strokeScaleEnabled) {
              this.save();
              const pixelRatio = this.getCanvas().getPixelRatio();
              this.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
            }
            this._applyLineCap(shape);
            const hitStrokeWidth = shape.hitStrokeWidth();
            const strokeWidth = hitStrokeWidth === "auto" ? shape.strokeWidth() : hitStrokeWidth;
            this.setAttr("lineWidth", strokeWidth);
            this.setAttr("strokeStyle", shape.colorKey);
            shape._strokeFuncHit(this);
            if (!strokeScaleEnabled) {
              this.restore();
            }
          }
        }
      }
      let _pixelRatio;
      function getDevicePixelRatio() {
        if (_pixelRatio) {
          return _pixelRatio;
        }
        const canvas = Util.createCanvasElement();
        const context = canvas.getContext("2d");
        _pixelRatio = function() {
          const devicePixelRatio = Konva._global.devicePixelRatio || 1, backingStoreRatio = context.webkitBackingStorePixelRatio || context.mozBackingStorePixelRatio || context.msBackingStorePixelRatio || context.oBackingStorePixelRatio || context.backingStorePixelRatio || 1;
          return devicePixelRatio / backingStoreRatio;
        }();
        Util.releaseCanvas(canvas);
        return _pixelRatio;
      }
      class Canvas {
        constructor(config) {
          this.pixelRatio = 1;
          this.width = 0;
          this.height = 0;
          this.isCache = false;
          const conf = config || {};
          const pixelRatio = conf.pixelRatio || Konva.pixelRatio || getDevicePixelRatio();
          this.pixelRatio = pixelRatio;
          this._canvas = Util.createCanvasElement();
          this._canvas.style.padding = "0";
          this._canvas.style.margin = "0";
          this._canvas.style.border = "0";
          this._canvas.style.background = "transparent";
          this._canvas.style.position = "absolute";
          this._canvas.style.top = "0";
          this._canvas.style.left = "0";
        }
        getContext() {
          return this.context;
        }
        getPixelRatio() {
          return this.pixelRatio;
        }
        setPixelRatio(pixelRatio) {
          const previousRatio = this.pixelRatio;
          this.pixelRatio = pixelRatio;
          this.setSize(this.getWidth() / previousRatio, this.getHeight() / previousRatio);
        }
        setWidth(width) {
          this.width = this._canvas.width = width * this.pixelRatio;
          this._canvas.style.width = width + "px";
          const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
          _context.scale(pixelRatio, pixelRatio);
        }
        setHeight(height) {
          this.height = this._canvas.height = height * this.pixelRatio;
          this._canvas.style.height = height + "px";
          const pixelRatio = this.pixelRatio, _context = this.getContext()._context;
          _context.scale(pixelRatio, pixelRatio);
        }
        getWidth() {
          return this.width;
        }
        getHeight() {
          return this.height;
        }
        setSize(width, height) {
          this.setWidth(width || 0);
          this.setHeight(height || 0);
        }
        toDataURL(mimeType, quality) {
          try {
            return this._canvas.toDataURL(mimeType, quality);
          } catch (e) {
            try {
              return this._canvas.toDataURL();
            } catch (err) {
              Util.error("Unable to get data URL. " + err.message + " For more info read https://konvajs.org/docs/posts/Tainted_Canvas.html.");
              return "";
            }
          }
        }
      }
      class SceneCanvas extends Canvas {
        constructor(config = { width: 0, height: 0, willReadFrequently: false }) {
          super(config);
          this.context = new SceneContext(this, {
            willReadFrequently: config.willReadFrequently
          });
          this.setSize(config.width, config.height);
        }
      }
      class HitCanvas extends Canvas {
        constructor(config = { width: 0, height: 0 }) {
          super(config);
          this.hitCanvas = true;
          this.context = new HitContext(this);
          this.setSize(config.width, config.height);
        }
      }
      const DD = {
        get isDragging() {
          let flag = false;
          DD._dragElements.forEach((elem) => {
            if (elem.dragStatus === "dragging") {
              flag = true;
            }
          });
          return flag;
        },
        justDragged: false,
        get node() {
          let node;
          DD._dragElements.forEach((elem) => {
            node = elem.node;
          });
          return node;
        },
        _dragElements: /* @__PURE__ */ new Map(),
        _drag(evt) {
          const nodesToFireEvents = [];
          DD._dragElements.forEach((elem, key) => {
            const { node } = elem;
            const stage = node.getStage();
            stage.setPointersPositions(evt);
            if (elem.pointerId === void 0) {
              elem.pointerId = Util._getFirstPointerId(evt);
            }
            const pos = stage._changedPointerPositions.find((pos2) => pos2.id === elem.pointerId);
            if (!pos) {
              return;
            }
            if (elem.dragStatus !== "dragging") {
              const dragDistance = node.dragDistance();
              const distance = Math.max(Math.abs(pos.x - elem.startPointerPos.x), Math.abs(pos.y - elem.startPointerPos.y));
              if (distance < dragDistance) {
                return;
              }
              node.startDrag({ evt });
              if (!node.isDragging()) {
                return;
              }
            }
            node._setDragPosition(evt, elem);
            nodesToFireEvents.push(node);
          });
          nodesToFireEvents.forEach((node) => {
            node.fire("dragmove", {
              type: "dragmove",
              target: node,
              evt
            }, true);
          });
        },
        _endDragBefore(evt) {
          const drawNodes = [];
          DD._dragElements.forEach((elem) => {
            const { node } = elem;
            const stage = node.getStage();
            if (evt) {
              stage.setPointersPositions(evt);
            }
            const pos = stage._changedPointerPositions.find((pos2) => pos2.id === elem.pointerId);
            if (!pos) {
              return;
            }
            if (elem.dragStatus === "dragging" || elem.dragStatus === "stopped") {
              DD.justDragged = true;
              Konva._mouseListenClick = false;
              Konva._touchListenClick = false;
              Konva._pointerListenClick = false;
              elem.dragStatus = "stopped";
            }
            const drawNode = elem.node.getLayer() || elem.node instanceof Konva["Stage"] && elem.node;
            if (drawNode && drawNodes.indexOf(drawNode) === -1) {
              drawNodes.push(drawNode);
            }
          });
          drawNodes.forEach((drawNode) => {
            drawNode.draw();
          });
        },
        _endDragAfter(evt) {
          DD._dragElements.forEach((elem, key) => {
            if (elem.dragStatus === "stopped") {
              elem.node.fire("dragend", {
                type: "dragend",
                target: elem.node,
                evt
              }, true);
            }
            if (elem.dragStatus !== "dragging") {
              DD._dragElements.delete(key);
            }
          });
        }
      };
      if (Konva.isBrowser) {
        window.addEventListener("mouseup", DD._endDragBefore, true);
        window.addEventListener("touchend", DD._endDragBefore, true);
        window.addEventListener("touchcancel", DD._endDragBefore, true);
        window.addEventListener("mousemove", DD._drag);
        window.addEventListener("touchmove", DD._drag);
        window.addEventListener("mouseup", DD._endDragAfter, false);
        window.addEventListener("touchend", DD._endDragAfter, false);
        window.addEventListener("touchcancel", DD._endDragAfter, false);
      }
      const ABSOLUTE_OPACITY = "absoluteOpacity", ALL_LISTENERS = "allEventListeners", ABSOLUTE_TRANSFORM = "absoluteTransform", ABSOLUTE_SCALE = "absoluteScale", CANVAS = "canvas", CHANGE = "Change", CHILDREN = "children", KONVA = "konva", LISTENING = "listening", MOUSEENTER$1 = "mouseenter", MOUSELEAVE$1 = "mouseleave", POINTERENTER$1 = "pointerenter", POINTERLEAVE$1 = "pointerleave", TOUCHENTER = "touchenter", TOUCHLEAVE = "touchleave", SET = "set", SHAPE = "Shape", SPACE = " ", STAGE$1 = "stage", TRANSFORM = "transform", UPPER_STAGE = "Stage", VISIBLE = "visible", TRANSFORM_CHANGE_STR = [
        "xChange.konva",
        "yChange.konva",
        "scaleXChange.konva",
        "scaleYChange.konva",
        "skewXChange.konva",
        "skewYChange.konva",
        "rotationChange.konva",
        "offsetXChange.konva",
        "offsetYChange.konva",
        "transformsEnabledChange.konva"
      ].join(SPACE);
      let idCounter$1 = 1;
      class Node {
        constructor(config) {
          this._id = idCounter$1++;
          this.eventListeners = {};
          this.attrs = {};
          this.index = 0;
          this._allEventListeners = null;
          this.parent = null;
          this._cache = /* @__PURE__ */ new Map();
          this._attachedDepsListeners = /* @__PURE__ */ new Map();
          this._lastPos = null;
          this._batchingTransformChange = false;
          this._needClearTransformCache = false;
          this._filterUpToDate = false;
          this._isUnderCache = false;
          this._dragEventId = null;
          this._shouldFireChangeEvents = false;
          this.setAttrs(config);
          this._shouldFireChangeEvents = true;
        }
        hasChildren() {
          return false;
        }
        _clearCache(attr) {
          if ((attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM) && this._cache.get(attr)) {
            this._cache.get(attr).dirty = true;
          } else if (attr) {
            this._cache.delete(attr);
          } else {
            this._cache.clear();
          }
        }
        _getCache(attr, privateGetter) {
          let cache = this._cache.get(attr);
          const isTransform = attr === TRANSFORM || attr === ABSOLUTE_TRANSFORM;
          const invalid = cache === void 0 || isTransform && cache.dirty === true;
          if (invalid) {
            cache = privateGetter.call(this);
            this._cache.set(attr, cache);
          }
          return cache;
        }
        _calculate(name, deps, getter) {
          if (!this._attachedDepsListeners.get(name)) {
            const depsString = deps.map((dep) => dep + "Change.konva").join(SPACE);
            this.on(depsString, () => {
              this._clearCache(name);
            });
            this._attachedDepsListeners.set(name, true);
          }
          return this._getCache(name, getter);
        }
        _getCanvasCache() {
          return this._cache.get(CANVAS);
        }
        _clearSelfAndDescendantCache(attr) {
          this._clearCache(attr);
          if (attr === ABSOLUTE_TRANSFORM) {
            this.fire("absoluteTransformChange");
          }
        }
        clearCache() {
          if (this._cache.has(CANVAS)) {
            const { scene, filter, hit, buffer } = this._cache.get(CANVAS);
            Util.releaseCanvas(scene, filter, hit, buffer);
            this._cache.delete(CANVAS);
          }
          this._clearSelfAndDescendantCache();
          this._requestDraw();
          return this;
        }
        cache(config) {
          const conf = config || {};
          let rect = {};
          if (conf.x === void 0 || conf.y === void 0 || conf.width === void 0 || conf.height === void 0) {
            rect = this.getClientRect({
              skipTransform: true,
              relativeTo: this.getParent() || void 0
            });
          }
          let width = Math.ceil(conf.width || rect.width), height = Math.ceil(conf.height || rect.height), pixelRatio = conf.pixelRatio, x = conf.x === void 0 ? Math.floor(rect.x) : conf.x, y = conf.y === void 0 ? Math.floor(rect.y) : conf.y, offset = conf.offset || 0, drawBorder = conf.drawBorder || false, hitCanvasPixelRatio = conf.hitCanvasPixelRatio || 1;
          if (!width || !height) {
            Util.error("Can not cache the node. Width or height of the node equals 0. Caching is skipped.");
            return;
          }
          const extraPaddingX = Math.abs(Math.round(rect.x) - x) > 0.5 ? 1 : 0;
          const extraPaddingY = Math.abs(Math.round(rect.y) - y) > 0.5 ? 1 : 0;
          width += offset * 2 + extraPaddingX;
          height += offset * 2 + extraPaddingY;
          x -= offset;
          y -= offset;
          const cachedSceneCanvas = new SceneCanvas({
            pixelRatio,
            width,
            height
          }), cachedFilterCanvas = new SceneCanvas({
            pixelRatio,
            width: 0,
            height: 0,
            willReadFrequently: true
          }), cachedHitCanvas = new HitCanvas({
            pixelRatio: hitCanvasPixelRatio,
            width,
            height
          }), sceneContext = cachedSceneCanvas.getContext(), hitContext = cachedHitCanvas.getContext();
          const bufferCanvas = new SceneCanvas({
            width: cachedSceneCanvas.width / cachedSceneCanvas.pixelRatio + Math.abs(x),
            height: cachedSceneCanvas.height / cachedSceneCanvas.pixelRatio + Math.abs(y),
            pixelRatio: cachedSceneCanvas.pixelRatio
          }), bufferContext = bufferCanvas.getContext();
          cachedHitCanvas.isCache = true;
          cachedSceneCanvas.isCache = true;
          this._cache.delete(CANVAS);
          this._filterUpToDate = false;
          if (conf.imageSmoothingEnabled === false) {
            cachedSceneCanvas.getContext()._context.imageSmoothingEnabled = false;
            cachedFilterCanvas.getContext()._context.imageSmoothingEnabled = false;
          }
          sceneContext.save();
          hitContext.save();
          bufferContext.save();
          sceneContext.translate(-x, -y);
          hitContext.translate(-x, -y);
          bufferContext.translate(-x, -y);
          bufferCanvas.x = x;
          bufferCanvas.y = y;
          this._isUnderCache = true;
          this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
          this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
          this.drawScene(cachedSceneCanvas, this, bufferCanvas);
          this.drawHit(cachedHitCanvas, this);
          this._isUnderCache = false;
          sceneContext.restore();
          hitContext.restore();
          if (drawBorder) {
            sceneContext.save();
            sceneContext.beginPath();
            sceneContext.rect(0, 0, width, height);
            sceneContext.closePath();
            sceneContext.setAttr("strokeStyle", "red");
            sceneContext.setAttr("lineWidth", 5);
            sceneContext.stroke();
            sceneContext.restore();
          }
          this._cache.set(CANVAS, {
            scene: cachedSceneCanvas,
            filter: cachedFilterCanvas,
            hit: cachedHitCanvas,
            buffer: bufferCanvas,
            x,
            y
          });
          this._requestDraw();
          return this;
        }
        isCached() {
          return this._cache.has(CANVAS);
        }
        getClientRect(config) {
          throw new Error('abstract "getClientRect" method call');
        }
        _transformedRect(rect, top) {
          const points = [
            { x: rect.x, y: rect.y },
            { x: rect.x + rect.width, y: rect.y },
            { x: rect.x + rect.width, y: rect.y + rect.height },
            { x: rect.x, y: rect.y + rect.height }
          ];
          let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
          const trans = this.getAbsoluteTransform(top);
          points.forEach(function(point) {
            const transformed = trans.point(point);
            if (minX === void 0) {
              minX = maxX = transformed.x;
              minY = maxY = transformed.y;
            }
            minX = Math.min(minX, transformed.x);
            minY = Math.min(minY, transformed.y);
            maxX = Math.max(maxX, transformed.x);
            maxY = Math.max(maxY, transformed.y);
          });
          return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
          };
        }
        _drawCachedSceneCanvas(context) {
          context.save();
          context._applyOpacity(this);
          context._applyGlobalCompositeOperation(this);
          const canvasCache = this._getCanvasCache();
          context.translate(canvasCache.x, canvasCache.y);
          const cacheCanvas = this._getCachedSceneCanvas();
          const ratio = cacheCanvas.pixelRatio;
          context.drawImage(cacheCanvas._canvas, 0, 0, cacheCanvas.width / ratio, cacheCanvas.height / ratio);
          context.restore();
        }
        _drawCachedHitCanvas(context) {
          const canvasCache = this._getCanvasCache(), hitCanvas = canvasCache.hit;
          context.save();
          context.translate(canvasCache.x, canvasCache.y);
          context.drawImage(hitCanvas._canvas, 0, 0, hitCanvas.width / hitCanvas.pixelRatio, hitCanvas.height / hitCanvas.pixelRatio);
          context.restore();
        }
        _getCachedSceneCanvas() {
          let filters = this.filters(), cachedCanvas = this._getCanvasCache(), sceneCanvas = cachedCanvas.scene, filterCanvas = cachedCanvas.filter, filterContext = filterCanvas.getContext(), len, imageData, n, filter;
          if (filters) {
            if (!this._filterUpToDate) {
              const ratio = sceneCanvas.pixelRatio;
              filterCanvas.setSize(sceneCanvas.width / sceneCanvas.pixelRatio, sceneCanvas.height / sceneCanvas.pixelRatio);
              try {
                len = filters.length;
                filterContext.clear();
                filterContext.drawImage(sceneCanvas._canvas, 0, 0, sceneCanvas.getWidth() / ratio, sceneCanvas.getHeight() / ratio);
                imageData = filterContext.getImageData(0, 0, filterCanvas.getWidth(), filterCanvas.getHeight());
                for (n = 0; n < len; n++) {
                  filter = filters[n];
                  if (typeof filter !== "function") {
                    Util.error("Filter should be type of function, but got " + typeof filter + " instead. Please check correct filters");
                    continue;
                  }
                  filter.call(this, imageData);
                  filterContext.putImageData(imageData, 0, 0);
                }
              } catch (e) {
                Util.error("Unable to apply filter. " + e.message + " This post my help you https://konvajs.org/docs/posts/Tainted_Canvas.html.");
              }
              this._filterUpToDate = true;
            }
            return filterCanvas;
          }
          return sceneCanvas;
        }
        on(evtStr, handler) {
          if (this._cache) {
            this._cache.delete(ALL_LISTENERS);
          }
          if (arguments.length === 3) {
            return this._delegate.apply(this, arguments);
          }
          const events = evtStr.split(SPACE);
          for (let n = 0; n < events.length; n++) {
            const event = events[n];
            const parts = event.split(".");
            const baseEvent = parts[0];
            const name = parts[1] || "";
            if (!this.eventListeners[baseEvent]) {
              this.eventListeners[baseEvent] = [];
            }
            this.eventListeners[baseEvent].push({ name, handler });
          }
          return this;
        }
        off(evtStr, callback) {
          let events = (evtStr || "").split(SPACE), len = events.length, n, t, event, parts, baseEvent, name;
          this._cache && this._cache.delete(ALL_LISTENERS);
          if (!evtStr) {
            for (t in this.eventListeners) {
              this._off(t);
            }
          }
          for (n = 0; n < len; n++) {
            event = events[n];
            parts = event.split(".");
            baseEvent = parts[0];
            name = parts[1];
            if (baseEvent) {
              if (this.eventListeners[baseEvent]) {
                this._off(baseEvent, name, callback);
              }
            } else {
              for (t in this.eventListeners) {
                this._off(t, name, callback);
              }
            }
          }
          return this;
        }
        dispatchEvent(evt) {
          const e = {
            target: this,
            type: evt.type,
            evt
          };
          this.fire(evt.type, e);
          return this;
        }
        addEventListener(type, handler) {
          this.on(type, function(evt) {
            handler.call(this, evt.evt);
          });
          return this;
        }
        removeEventListener(type) {
          this.off(type);
          return this;
        }
        _delegate(event, selector, handler) {
          const stopNode = this;
          this.on(event, function(evt) {
            const targets = evt.target.findAncestors(selector, true, stopNode);
            for (let i = 0; i < targets.length; i++) {
              evt = Util.cloneObject(evt);
              evt.currentTarget = targets[i];
              handler.call(targets[i], evt);
            }
          });
        }
        remove() {
          if (this.isDragging()) {
            this.stopDrag();
          }
          DD._dragElements.delete(this._id);
          this._remove();
          return this;
        }
        _clearCaches() {
          this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
          this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
          this._clearSelfAndDescendantCache(ABSOLUTE_SCALE);
          this._clearSelfAndDescendantCache(STAGE$1);
          this._clearSelfAndDescendantCache(VISIBLE);
          this._clearSelfAndDescendantCache(LISTENING);
        }
        _remove() {
          this._clearCaches();
          const parent = this.getParent();
          if (parent && parent.children) {
            parent.children.splice(this.index, 1);
            parent._setChildrenIndices();
            this.parent = null;
          }
        }
        destroy() {
          this.remove();
          this.clearCache();
          return this;
        }
        getAttr(attr) {
          const method = "get" + Util._capitalize(attr);
          if (Util._isFunction(this[method])) {
            return this[method]();
          }
          return this.attrs[attr];
        }
        getAncestors() {
          let parent = this.getParent(), ancestors = [];
          while (parent) {
            ancestors.push(parent);
            parent = parent.getParent();
          }
          return ancestors;
        }
        getAttrs() {
          return this.attrs || {};
        }
        setAttrs(config) {
          this._batchTransformChanges(() => {
            let key, method;
            if (!config) {
              return this;
            }
            for (key in config) {
              if (key === CHILDREN) {
                continue;
              }
              method = SET + Util._capitalize(key);
              if (Util._isFunction(this[method])) {
                this[method](config[key]);
              } else {
                this._setAttr(key, config[key]);
              }
            }
          });
          return this;
        }
        isListening() {
          return this._getCache(LISTENING, this._isListening);
        }
        _isListening(relativeTo) {
          const listening = this.listening();
          if (!listening) {
            return false;
          }
          const parent = this.getParent();
          if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isListening(relativeTo);
          } else {
            return true;
          }
        }
        isVisible() {
          return this._getCache(VISIBLE, this._isVisible);
        }
        _isVisible(relativeTo) {
          const visible = this.visible();
          if (!visible) {
            return false;
          }
          const parent = this.getParent();
          if (parent && parent !== relativeTo && this !== relativeTo) {
            return parent._isVisible(relativeTo);
          } else {
            return true;
          }
        }
        shouldDrawHit(top, skipDragCheck = false) {
          if (top) {
            return this._isVisible(top) && this._isListening(top);
          }
          const layer = this.getLayer();
          let layerUnderDrag = false;
          DD._dragElements.forEach((elem) => {
            if (elem.dragStatus !== "dragging") {
              return;
            } else if (elem.node.nodeType === "Stage") {
              layerUnderDrag = true;
            } else if (elem.node.getLayer() === layer) {
              layerUnderDrag = true;
            }
          });
          const dragSkip = !skipDragCheck && !Konva.hitOnDragEnabled && (layerUnderDrag || Konva.isTransforming());
          return this.isListening() && this.isVisible() && !dragSkip;
        }
        show() {
          this.visible(true);
          return this;
        }
        hide() {
          this.visible(false);
          return this;
        }
        getZIndex() {
          return this.index || 0;
        }
        getAbsoluteZIndex() {
          let depth = this.getDepth(), that = this, index = 0, nodes, len, n, child;
          function addChildren(children) {
            nodes = [];
            len = children.length;
            for (n = 0; n < len; n++) {
              child = children[n];
              index++;
              if (child.nodeType !== SHAPE) {
                nodes = nodes.concat(child.getChildren().slice());
              }
              if (child._id === that._id) {
                n = len;
              }
            }
            if (nodes.length > 0 && nodes[0].getDepth() <= depth) {
              addChildren(nodes);
            }
          }
          const stage = this.getStage();
          if (that.nodeType !== UPPER_STAGE && stage) {
            addChildren(stage.getChildren());
          }
          return index;
        }
        getDepth() {
          let depth = 0, parent = this.parent;
          while (parent) {
            depth++;
            parent = parent.parent;
          }
          return depth;
        }
        _batchTransformChanges(func) {
          this._batchingTransformChange = true;
          func();
          this._batchingTransformChange = false;
          if (this._needClearTransformCache) {
            this._clearCache(TRANSFORM);
            this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
          }
          this._needClearTransformCache = false;
        }
        setPosition(pos) {
          this._batchTransformChanges(() => {
            this.x(pos.x);
            this.y(pos.y);
          });
          return this;
        }
        getPosition() {
          return {
            x: this.x(),
            y: this.y()
          };
        }
        getRelativePointerPosition() {
          const stage = this.getStage();
          if (!stage) {
            return null;
          }
          const pos = stage.getPointerPosition();
          if (!pos) {
            return null;
          }
          const transform = this.getAbsoluteTransform().copy();
          transform.invert();
          return transform.point(pos);
        }
        getAbsolutePosition(top) {
          let haveCachedParent = false;
          let parent = this.parent;
          while (parent) {
            if (parent.isCached()) {
              haveCachedParent = true;
              break;
            }
            parent = parent.parent;
          }
          if (haveCachedParent && !top) {
            top = true;
          }
          const absoluteMatrix = this.getAbsoluteTransform(top).getMatrix(), absoluteTransform = new Transform(), offset = this.offset();
          absoluteTransform.m = absoluteMatrix.slice();
          absoluteTransform.translate(offset.x, offset.y);
          return absoluteTransform.getTranslation();
        }
        setAbsolutePosition(pos) {
          const { x, y, ...origTrans } = this._clearTransform();
          this.attrs.x = x;
          this.attrs.y = y;
          this._clearCache(TRANSFORM);
          const it = this._getAbsoluteTransform().copy();
          it.invert();
          it.translate(pos.x, pos.y);
          pos = {
            x: this.attrs.x + it.getTranslation().x,
            y: this.attrs.y + it.getTranslation().y
          };
          this._setTransform(origTrans);
          this.setPosition({ x: pos.x, y: pos.y });
          this._clearCache(TRANSFORM);
          this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
          return this;
        }
        _setTransform(trans) {
          let key;
          for (key in trans) {
            this.attrs[key] = trans[key];
          }
        }
        _clearTransform() {
          const trans = {
            x: this.x(),
            y: this.y(),
            rotation: this.rotation(),
            scaleX: this.scaleX(),
            scaleY: this.scaleY(),
            offsetX: this.offsetX(),
            offsetY: this.offsetY(),
            skewX: this.skewX(),
            skewY: this.skewY()
          };
          this.attrs.x = 0;
          this.attrs.y = 0;
          this.attrs.rotation = 0;
          this.attrs.scaleX = 1;
          this.attrs.scaleY = 1;
          this.attrs.offsetX = 0;
          this.attrs.offsetY = 0;
          this.attrs.skewX = 0;
          this.attrs.skewY = 0;
          return trans;
        }
        move(change) {
          let changeX = change.x, changeY = change.y, x = this.x(), y = this.y();
          if (changeX !== void 0) {
            x += changeX;
          }
          if (changeY !== void 0) {
            y += changeY;
          }
          this.setPosition({ x, y });
          return this;
        }
        _eachAncestorReverse(func, top) {
          let family = [], parent = this.getParent(), len, n;
          if (top && top._id === this._id) {
            return;
          }
          family.unshift(this);
          while (parent && (!top || parent._id !== top._id)) {
            family.unshift(parent);
            parent = parent.parent;
          }
          len = family.length;
          for (n = 0; n < len; n++) {
            func(family[n]);
          }
        }
        rotate(theta) {
          this.rotation(this.rotation() + theta);
          return this;
        }
        moveToTop() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveToTop function is ignored.");
            return false;
          }
          const index = this.index, len = this.parent.getChildren().length;
          if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.push(this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        moveUp() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveUp function is ignored.");
            return false;
          }
          const index = this.index, len = this.parent.getChildren().length;
          if (index < len - 1) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index + 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        moveDown() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveDown function is ignored.");
            return false;
          }
          const index = this.index;
          if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.splice(index - 1, 0, this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        moveToBottom() {
          if (!this.parent) {
            Util.warn("Node has no parent. moveToBottom function is ignored.");
            return false;
          }
          const index = this.index;
          if (index > 0) {
            this.parent.children.splice(index, 1);
            this.parent.children.unshift(this);
            this.parent._setChildrenIndices();
            return true;
          }
          return false;
        }
        setZIndex(zIndex) {
          if (!this.parent) {
            Util.warn("Node has no parent. zIndex parameter is ignored.");
            return this;
          }
          if (zIndex < 0 || zIndex >= this.parent.children.length) {
            Util.warn("Unexpected value " + zIndex + " for zIndex property. zIndex is just index of a node in children of its parent. Expected value is from 0 to " + (this.parent.children.length - 1) + ".");
          }
          const index = this.index;
          this.parent.children.splice(index, 1);
          this.parent.children.splice(zIndex, 0, this);
          this.parent._setChildrenIndices();
          return this;
        }
        getAbsoluteOpacity() {
          return this._getCache(ABSOLUTE_OPACITY, this._getAbsoluteOpacity);
        }
        _getAbsoluteOpacity() {
          let absOpacity = this.opacity();
          const parent = this.getParent();
          if (parent && !parent._isUnderCache) {
            absOpacity *= parent.getAbsoluteOpacity();
          }
          return absOpacity;
        }
        moveTo(newContainer) {
          if (this.getParent() !== newContainer) {
            this._remove();
            newContainer.add(this);
          }
          return this;
        }
        toObject() {
          let attrs = this.getAttrs(), key, val, getter, defaultValue, nonPlainObject;
          const obj = {
            attrs: {},
            className: this.getClassName()
          };
          for (key in attrs) {
            val = attrs[key];
            nonPlainObject = Util.isObject(val) && !Util._isPlainObject(val) && !Util._isArray(val);
            if (nonPlainObject) {
              continue;
            }
            getter = typeof this[key] === "function" && this[key];
            delete attrs[key];
            defaultValue = getter ? getter.call(this) : null;
            attrs[key] = val;
            if (defaultValue !== val) {
              obj.attrs[key] = val;
            }
          }
          return Util._prepareToStringify(obj);
        }
        toJSON() {
          return JSON.stringify(this.toObject());
        }
        getParent() {
          return this.parent;
        }
        findAncestors(selector, includeSelf, stopNode) {
          const res = [];
          if (includeSelf && this._isMatch(selector)) {
            res.push(this);
          }
          let ancestor = this.parent;
          while (ancestor) {
            if (ancestor === stopNode) {
              return res;
            }
            if (ancestor._isMatch(selector)) {
              res.push(ancestor);
            }
            ancestor = ancestor.parent;
          }
          return res;
        }
        isAncestorOf(node) {
          return false;
        }
        findAncestor(selector, includeSelf, stopNode) {
          return this.findAncestors(selector, includeSelf, stopNode)[0];
        }
        _isMatch(selector) {
          if (!selector) {
            return false;
          }
          if (typeof selector === "function") {
            return selector(this);
          }
          let selectorArr = selector.replace(/ /g, "").split(","), len = selectorArr.length, n, sel;
          for (n = 0; n < len; n++) {
            sel = selectorArr[n];
            if (!Util.isValidSelector(sel)) {
              Util.warn('Selector "' + sel + '" is invalid. Allowed selectors examples are "#foo", ".bar" or "Group".');
              Util.warn('If you have a custom shape with such className, please change it to start with upper letter like "Triangle".');
              Util.warn("Konva is awesome, right?");
            }
            if (sel.charAt(0) === "#") {
              if (this.id() === sel.slice(1)) {
                return true;
              }
            } else if (sel.charAt(0) === ".") {
              if (this.hasName(sel.slice(1))) {
                return true;
              }
            } else if (this.className === sel || this.nodeType === sel) {
              return true;
            }
          }
          return false;
        }
        getLayer() {
          const parent = this.getParent();
          return parent ? parent.getLayer() : null;
        }
        getStage() {
          return this._getCache(STAGE$1, this._getStage);
        }
        _getStage() {
          const parent = this.getParent();
          if (parent) {
            return parent.getStage();
          } else {
            return null;
          }
        }
        fire(eventType, evt = {}, bubble) {
          evt.target = evt.target || this;
          if (bubble) {
            this._fireAndBubble(eventType, evt);
          } else {
            this._fire(eventType, evt);
          }
          return this;
        }
        getAbsoluteTransform(top) {
          if (top) {
            return this._getAbsoluteTransform(top);
          } else {
            return this._getCache(ABSOLUTE_TRANSFORM, this._getAbsoluteTransform);
          }
        }
        _getAbsoluteTransform(top) {
          let at;
          if (top) {
            at = new Transform();
            this._eachAncestorReverse(function(node) {
              const transformsEnabled = node.transformsEnabled();
              if (transformsEnabled === "all") {
                at.multiply(node.getTransform());
              } else if (transformsEnabled === "position") {
                at.translate(node.x() - node.offsetX(), node.y() - node.offsetY());
              }
            }, top);
            return at;
          } else {
            at = this._cache.get(ABSOLUTE_TRANSFORM) || new Transform();
            if (this.parent) {
              this.parent.getAbsoluteTransform().copyInto(at);
            } else {
              at.reset();
            }
            const transformsEnabled = this.transformsEnabled();
            if (transformsEnabled === "all") {
              at.multiply(this.getTransform());
            } else if (transformsEnabled === "position") {
              const x = this.attrs.x || 0;
              const y = this.attrs.y || 0;
              const offsetX = this.attrs.offsetX || 0;
              const offsetY = this.attrs.offsetY || 0;
              at.translate(x - offsetX, y - offsetY);
            }
            at.dirty = false;
            return at;
          }
        }
        getAbsoluteScale(top) {
          let parent = this;
          while (parent) {
            if (parent._isUnderCache) {
              top = parent;
            }
            parent = parent.getParent();
          }
          const transform = this.getAbsoluteTransform(top);
          const attrs = transform.decompose();
          return {
            x: attrs.scaleX,
            y: attrs.scaleY
          };
        }
        getAbsoluteRotation() {
          return this.getAbsoluteTransform().decompose().rotation;
        }
        getTransform() {
          return this._getCache(TRANSFORM, this._getTransform);
        }
        _getTransform() {
          var _a, _b;
          const m = this._cache.get(TRANSFORM) || new Transform();
          m.reset();
          const x = this.x(), y = this.y(), rotation = Konva.getAngle(this.rotation()), scaleX = (_a = this.attrs.scaleX) !== null && _a !== void 0 ? _a : 1, scaleY = (_b = this.attrs.scaleY) !== null && _b !== void 0 ? _b : 1, skewX = this.attrs.skewX || 0, skewY = this.attrs.skewY || 0, offsetX = this.attrs.offsetX || 0, offsetY = this.attrs.offsetY || 0;
          if (x !== 0 || y !== 0) {
            m.translate(x, y);
          }
          if (rotation !== 0) {
            m.rotate(rotation);
          }
          if (skewX !== 0 || skewY !== 0) {
            m.skew(skewX, skewY);
          }
          if (scaleX !== 1 || scaleY !== 1) {
            m.scale(scaleX, scaleY);
          }
          if (offsetX !== 0 || offsetY !== 0) {
            m.translate(-1 * offsetX, -1 * offsetY);
          }
          m.dirty = false;
          return m;
        }
        clone(obj) {
          let attrs = Util.cloneObject(this.attrs), key, allListeners, len, n, listener;
          for (key in obj) {
            attrs[key] = obj[key];
          }
          const node = new this.constructor(attrs);
          for (key in this.eventListeners) {
            allListeners = this.eventListeners[key];
            len = allListeners.length;
            for (n = 0; n < len; n++) {
              listener = allListeners[n];
              if (listener.name.indexOf(KONVA) < 0) {
                if (!node.eventListeners[key]) {
                  node.eventListeners[key] = [];
                }
                node.eventListeners[key].push(listener);
              }
            }
          }
          return node;
        }
        _toKonvaCanvas(config) {
          config = config || {};
          const box = this.getClientRect();
          const stage = this.getStage(), x = config.x !== void 0 ? config.x : Math.floor(box.x), y = config.y !== void 0 ? config.y : Math.floor(box.y), pixelRatio = config.pixelRatio || 1, canvas = new SceneCanvas({
            width: config.width || Math.ceil(box.width) || (stage ? stage.width() : 0),
            height: config.height || Math.ceil(box.height) || (stage ? stage.height() : 0),
            pixelRatio
          }), context = canvas.getContext();
          const bufferCanvas = new SceneCanvas({
            width: canvas.width / canvas.pixelRatio + Math.abs(x),
            height: canvas.height / canvas.pixelRatio + Math.abs(y),
            pixelRatio: canvas.pixelRatio
          });
          if (config.imageSmoothingEnabled === false) {
            context._context.imageSmoothingEnabled = false;
          }
          context.save();
          if (x || y) {
            context.translate(-1 * x, -1 * y);
          }
          this.drawScene(canvas, void 0, bufferCanvas);
          context.restore();
          return canvas;
        }
        toCanvas(config) {
          return this._toKonvaCanvas(config)._canvas;
        }
        toDataURL(config) {
          config = config || {};
          const mimeType = config.mimeType || null, quality = config.quality || null;
          const url = this._toKonvaCanvas(config).toDataURL(mimeType, quality);
          if (config.callback) {
            config.callback(url);
          }
          return url;
        }
        toImage(config) {
          return new Promise((resolve, reject) => {
            try {
              const callback = config === null || config === void 0 ? void 0 : config.callback;
              if (callback)
                delete config.callback;
              Util._urlToImage(this.toDataURL(config), function(img) {
                resolve(img);
                callback === null || callback === void 0 ? void 0 : callback(img);
              });
            } catch (err) {
              reject(err);
            }
          });
        }
        toBlob(config) {
          return new Promise((resolve, reject) => {
            try {
              const callback = config === null || config === void 0 ? void 0 : config.callback;
              if (callback)
                delete config.callback;
              this.toCanvas(config).toBlob((blob) => {
                resolve(blob);
                callback === null || callback === void 0 ? void 0 : callback(blob);
              }, config === null || config === void 0 ? void 0 : config.mimeType, config === null || config === void 0 ? void 0 : config.quality);
            } catch (err) {
              reject(err);
            }
          });
        }
        setSize(size) {
          this.width(size.width);
          this.height(size.height);
          return this;
        }
        getSize() {
          return {
            width: this.width(),
            height: this.height()
          };
        }
        getClassName() {
          return this.className || this.nodeType;
        }
        getType() {
          return this.nodeType;
        }
        getDragDistance() {
          if (this.attrs.dragDistance !== void 0) {
            return this.attrs.dragDistance;
          } else if (this.parent) {
            return this.parent.getDragDistance();
          } else {
            return Konva.dragDistance;
          }
        }
        _off(type, name, callback) {
          let evtListeners = this.eventListeners[type], i, evtName, handler;
          for (i = 0; i < evtListeners.length; i++) {
            evtName = evtListeners[i].name;
            handler = evtListeners[i].handler;
            if ((evtName !== "konva" || name === "konva") && (!name || evtName === name) && (!callback || callback === handler)) {
              evtListeners.splice(i, 1);
              if (evtListeners.length === 0) {
                delete this.eventListeners[type];
                break;
              }
              i--;
            }
          }
        }
        _fireChangeEvent(attr, oldVal, newVal) {
          this._fire(attr + CHANGE, {
            oldVal,
            newVal
          });
        }
        addName(name) {
          if (!this.hasName(name)) {
            const oldName = this.name();
            const newName = oldName ? oldName + " " + name : name;
            this.name(newName);
          }
          return this;
        }
        hasName(name) {
          if (!name) {
            return false;
          }
          const fullName = this.name();
          if (!fullName) {
            return false;
          }
          const names = (fullName || "").split(/\s/g);
          return names.indexOf(name) !== -1;
        }
        removeName(name) {
          const names = (this.name() || "").split(/\s/g);
          const index = names.indexOf(name);
          if (index !== -1) {
            names.splice(index, 1);
            this.name(names.join(" "));
          }
          return this;
        }
        setAttr(attr, val) {
          const func = this[SET + Util._capitalize(attr)];
          if (Util._isFunction(func)) {
            func.call(this, val);
          } else {
            this._setAttr(attr, val);
          }
          return this;
        }
        _requestDraw() {
          if (Konva.autoDrawEnabled) {
            const drawNode = this.getLayer() || this.getStage();
            drawNode === null || drawNode === void 0 ? void 0 : drawNode.batchDraw();
          }
        }
        _setAttr(key, val) {
          const oldVal = this.attrs[key];
          if (oldVal === val && !Util.isObject(val)) {
            return;
          }
          if (val === void 0 || val === null) {
            delete this.attrs[key];
          } else {
            this.attrs[key] = val;
          }
          if (this._shouldFireChangeEvents) {
            this._fireChangeEvent(key, oldVal, val);
          }
          this._requestDraw();
        }
        _setComponentAttr(key, component, val) {
          let oldVal;
          if (val !== void 0) {
            oldVal = this.attrs[key];
            if (!oldVal) {
              this.attrs[key] = this.getAttr(key);
            }
            this.attrs[key][component] = val;
            this._fireChangeEvent(key, oldVal, val);
          }
        }
        _fireAndBubble(eventType, evt, compareShape) {
          if (evt && this.nodeType === SHAPE) {
            evt.target = this;
          }
          const nonBubbling = [
            MOUSEENTER$1,
            MOUSELEAVE$1,
            POINTERENTER$1,
            POINTERLEAVE$1,
            TOUCHENTER,
            TOUCHLEAVE
          ];
          const shouldStop = nonBubbling.indexOf(eventType) !== -1 && (compareShape && (this === compareShape || this.isAncestorOf && this.isAncestorOf(compareShape)) || this.nodeType === "Stage" && !compareShape);
          if (!shouldStop) {
            this._fire(eventType, evt);
            const stopBubble = nonBubbling.indexOf(eventType) !== -1 && compareShape && compareShape.isAncestorOf && compareShape.isAncestorOf(this) && !compareShape.isAncestorOf(this.parent);
            if ((evt && !evt.cancelBubble || !evt) && this.parent && this.parent.isListening() && !stopBubble) {
              if (compareShape && compareShape.parent) {
                this._fireAndBubble.call(this.parent, eventType, evt, compareShape);
              } else {
                this._fireAndBubble.call(this.parent, eventType, evt);
              }
            }
          }
        }
        _getProtoListeners(eventType) {
          var _a, _b, _c;
          const allListeners = (_a = this._cache.get(ALL_LISTENERS)) !== null && _a !== void 0 ? _a : {};
          let events = allListeners === null || allListeners === void 0 ? void 0 : allListeners[eventType];
          if (events === void 0) {
            events = [];
            let obj = Object.getPrototypeOf(this);
            while (obj) {
              const hierarchyEvents = (_c = (_b = obj.eventListeners) === null || _b === void 0 ? void 0 : _b[eventType]) !== null && _c !== void 0 ? _c : [];
              events.push(...hierarchyEvents);
              obj = Object.getPrototypeOf(obj);
            }
            allListeners[eventType] = events;
            this._cache.set(ALL_LISTENERS, allListeners);
          }
          return events;
        }
        _fire(eventType, evt) {
          evt = evt || {};
          evt.currentTarget = this;
          evt.type = eventType;
          const topListeners = this._getProtoListeners(eventType);
          if (topListeners) {
            for (let i = 0; i < topListeners.length; i++) {
              topListeners[i].handler.call(this, evt);
            }
          }
          const selfListeners = this.eventListeners[eventType];
          if (selfListeners) {
            for (let i = 0; i < selfListeners.length; i++) {
              selfListeners[i].handler.call(this, evt);
            }
          }
        }
        draw() {
          this.drawScene();
          this.drawHit();
          return this;
        }
        _createDragElement(evt) {
          const pointerId = evt ? evt.pointerId : void 0;
          const stage = this.getStage();
          const ap = this.getAbsolutePosition();
          if (!stage) {
            return;
          }
          const pos = stage._getPointerById(pointerId) || stage._changedPointerPositions[0] || ap;
          DD._dragElements.set(this._id, {
            node: this,
            startPointerPos: pos,
            offset: {
              x: pos.x - ap.x,
              y: pos.y - ap.y
            },
            dragStatus: "ready",
            pointerId
          });
        }
        startDrag(evt, bubbleEvent = true) {
          if (!DD._dragElements.has(this._id)) {
            this._createDragElement(evt);
          }
          const elem = DD._dragElements.get(this._id);
          elem.dragStatus = "dragging";
          this.fire("dragstart", {
            type: "dragstart",
            target: this,
            evt: evt && evt.evt
          }, bubbleEvent);
        }
        _setDragPosition(evt, elem) {
          const pos = this.getStage()._getPointerById(elem.pointerId);
          if (!pos) {
            return;
          }
          let newNodePos = {
            x: pos.x - elem.offset.x,
            y: pos.y - elem.offset.y
          };
          const dbf = this.dragBoundFunc();
          if (dbf !== void 0) {
            const bounded = dbf.call(this, newNodePos, evt);
            if (!bounded) {
              Util.warn("dragBoundFunc did not return any value. That is unexpected behavior. You must return new absolute position from dragBoundFunc.");
            } else {
              newNodePos = bounded;
            }
          }
          if (!this._lastPos || this._lastPos.x !== newNodePos.x || this._lastPos.y !== newNodePos.y) {
            this.setAbsolutePosition(newNodePos);
            this._requestDraw();
          }
          this._lastPos = newNodePos;
        }
        stopDrag(evt) {
          const elem = DD._dragElements.get(this._id);
          if (elem) {
            elem.dragStatus = "stopped";
          }
          DD._endDragBefore(evt);
          DD._endDragAfter(evt);
        }
        setDraggable(draggable) {
          this._setAttr("draggable", draggable);
          this._dragChange();
        }
        isDragging() {
          const elem = DD._dragElements.get(this._id);
          return elem ? elem.dragStatus === "dragging" : false;
        }
        _listenDrag() {
          this._dragCleanup();
          this.on("mousedown.konva touchstart.konva", function(evt) {
            const shouldCheckButton = evt.evt["button"] !== void 0;
            const canDrag = !shouldCheckButton || Konva.dragButtons.indexOf(evt.evt["button"]) >= 0;
            if (!canDrag) {
              return;
            }
            if (this.isDragging()) {
              return;
            }
            let hasDraggingChild = false;
            DD._dragElements.forEach((elem) => {
              if (this.isAncestorOf(elem.node)) {
                hasDraggingChild = true;
              }
            });
            if (!hasDraggingChild) {
              this._createDragElement(evt);
            }
          });
        }
        _dragChange() {
          if (this.attrs.draggable) {
            this._listenDrag();
          } else {
            this._dragCleanup();
            const stage = this.getStage();
            if (!stage) {
              return;
            }
            const dragElement = DD._dragElements.get(this._id);
            const isDragging = dragElement && dragElement.dragStatus === "dragging";
            const isReady = dragElement && dragElement.dragStatus === "ready";
            if (isDragging) {
              this.stopDrag();
            } else if (isReady) {
              DD._dragElements.delete(this._id);
            }
          }
        }
        _dragCleanup() {
          this.off("mousedown.konva");
          this.off("touchstart.konva");
        }
        isClientRectOnScreen(margin = { x: 0, y: 0 }) {
          const stage = this.getStage();
          if (!stage) {
            return false;
          }
          const screenRect = {
            x: -margin.x,
            y: -margin.y,
            width: stage.width() + 2 * margin.x,
            height: stage.height() + 2 * margin.y
          };
          return Util.haveIntersection(screenRect, this.getClientRect());
        }
        static create(data, container) {
          if (Util._isString(data)) {
            data = JSON.parse(data);
          }
          return this._createNode(data, container);
        }
        static _createNode(obj, container) {
          let className = Node.prototype.getClassName.call(obj), children = obj.children, no, len, n;
          if (container) {
            obj.attrs.container = container;
          }
          if (!Konva[className]) {
            Util.warn('Can not find a node with class name "' + className + '". Fallback to "Shape".');
            className = "Shape";
          }
          const Class = Konva[className];
          no = new Class(obj.attrs);
          if (children) {
            len = children.length;
            for (n = 0; n < len; n++) {
              no.add(Node._createNode(children[n]));
            }
          }
          return no;
        }
      }
      Node.prototype.nodeType = "Node";
      Node.prototype._attrsAffectingSize = [];
      Node.prototype.eventListeners = {};
      Node.prototype.on.call(Node.prototype, TRANSFORM_CHANGE_STR, function() {
        if (this._batchingTransformChange) {
          this._needClearTransformCache = true;
          return;
        }
        this._clearCache(TRANSFORM);
        this._clearSelfAndDescendantCache(ABSOLUTE_TRANSFORM);
      });
      Node.prototype.on.call(Node.prototype, "visibleChange.konva", function() {
        this._clearSelfAndDescendantCache(VISIBLE);
      });
      Node.prototype.on.call(Node.prototype, "listeningChange.konva", function() {
        this._clearSelfAndDescendantCache(LISTENING);
      });
      Node.prototype.on.call(Node.prototype, "opacityChange.konva", function() {
        this._clearSelfAndDescendantCache(ABSOLUTE_OPACITY);
      });
      const addGetterSetter = Factory.addGetterSetter;
      addGetterSetter(Node, "zIndex");
      addGetterSetter(Node, "absolutePosition");
      addGetterSetter(Node, "position");
      addGetterSetter(Node, "x", 0, getNumberValidator());
      addGetterSetter(Node, "y", 0, getNumberValidator());
      addGetterSetter(Node, "globalCompositeOperation", "source-over", getStringValidator());
      addGetterSetter(Node, "opacity", 1, getNumberValidator());
      addGetterSetter(Node, "name", "", getStringValidator());
      addGetterSetter(Node, "id", "", getStringValidator());
      addGetterSetter(Node, "rotation", 0, getNumberValidator());
      Factory.addComponentsGetterSetter(Node, "scale", ["x", "y"]);
      addGetterSetter(Node, "scaleX", 1, getNumberValidator());
      addGetterSetter(Node, "scaleY", 1, getNumberValidator());
      Factory.addComponentsGetterSetter(Node, "skew", ["x", "y"]);
      addGetterSetter(Node, "skewX", 0, getNumberValidator());
      addGetterSetter(Node, "skewY", 0, getNumberValidator());
      Factory.addComponentsGetterSetter(Node, "offset", ["x", "y"]);
      addGetterSetter(Node, "offsetX", 0, getNumberValidator());
      addGetterSetter(Node, "offsetY", 0, getNumberValidator());
      addGetterSetter(Node, "dragDistance", void 0, getNumberValidator());
      addGetterSetter(Node, "width", 0, getNumberValidator());
      addGetterSetter(Node, "height", 0, getNumberValidator());
      addGetterSetter(Node, "listening", true, getBooleanValidator());
      addGetterSetter(Node, "preventDefault", true, getBooleanValidator());
      addGetterSetter(Node, "filters", void 0, function(val) {
        this._filterUpToDate = false;
        return val;
      });
      addGetterSetter(Node, "visible", true, getBooleanValidator());
      addGetterSetter(Node, "transformsEnabled", "all", getStringValidator());
      addGetterSetter(Node, "size");
      addGetterSetter(Node, "dragBoundFunc");
      addGetterSetter(Node, "draggable", false, getBooleanValidator());
      Factory.backCompat(Node, {
        rotateDeg: "rotate",
        setRotationDeg: "setRotation",
        getRotationDeg: "getRotation"
      });
      class Container extends Node {
        constructor() {
          super(...arguments);
          this.children = [];
        }
        getChildren(filterFunc) {
          const children = this.children || [];
          if (filterFunc) {
            return children.filter(filterFunc);
          }
          return children;
        }
        hasChildren() {
          return this.getChildren().length > 0;
        }
        removeChildren() {
          this.getChildren().forEach((child) => {
            child.parent = null;
            child.index = 0;
            child.remove();
          });
          this.children = [];
          this._requestDraw();
          return this;
        }
        destroyChildren() {
          this.getChildren().forEach((child) => {
            child.parent = null;
            child.index = 0;
            child.destroy();
          });
          this.children = [];
          this._requestDraw();
          return this;
        }
        add(...children) {
          if (children.length === 0) {
            return this;
          }
          if (children.length > 1) {
            for (let i = 0; i < children.length; i++) {
              this.add(children[i]);
            }
            return this;
          }
          const child = children[0];
          if (child.getParent()) {
            child.moveTo(this);
            return this;
          }
          this._validateAdd(child);
          child.index = this.getChildren().length;
          child.parent = this;
          child._clearCaches();
          this.getChildren().push(child);
          this._fire("add", {
            child
          });
          this._requestDraw();
          return this;
        }
        destroy() {
          if (this.hasChildren()) {
            this.destroyChildren();
          }
          super.destroy();
          return this;
        }
        find(selector) {
          return this._generalFind(selector, false);
        }
        findOne(selector) {
          const result = this._generalFind(selector, true);
          return result.length > 0 ? result[0] : void 0;
        }
        _generalFind(selector, findOne) {
          const retArr = [];
          this._descendants((node) => {
            const valid = node._isMatch(selector);
            if (valid) {
              retArr.push(node);
            }
            if (valid && findOne) {
              return true;
            }
            return false;
          });
          return retArr;
        }
        _descendants(fn) {
          let shouldStop = false;
          const children = this.getChildren();
          for (const child of children) {
            shouldStop = fn(child);
            if (shouldStop) {
              return true;
            }
            if (!child.hasChildren()) {
              continue;
            }
            shouldStop = child._descendants(fn);
            if (shouldStop) {
              return true;
            }
          }
          return false;
        }
        toObject() {
          const obj = Node.prototype.toObject.call(this);
          obj.children = [];
          this.getChildren().forEach((child) => {
            obj.children.push(child.toObject());
          });
          return obj;
        }
        isAncestorOf(node) {
          let parent = node.getParent();
          while (parent) {
            if (parent._id === this._id) {
              return true;
            }
            parent = parent.getParent();
          }
          return false;
        }
        clone(obj) {
          const node = Node.prototype.clone.call(this, obj);
          this.getChildren().forEach(function(no) {
            node.add(no.clone());
          });
          return node;
        }
        getAllIntersections(pos) {
          const arr = [];
          this.find("Shape").forEach((shape) => {
            if (shape.isVisible() && shape.intersects(pos)) {
              arr.push(shape);
            }
          });
          return arr;
        }
        _clearSelfAndDescendantCache(attr) {
          var _a;
          super._clearSelfAndDescendantCache(attr);
          if (this.isCached()) {
            return;
          }
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(node) {
            node._clearSelfAndDescendantCache(attr);
          });
        }
        _setChildrenIndices() {
          var _a;
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(child, n) {
            child.index = n;
          });
          this._requestDraw();
        }
        drawScene(can, top, bufferCanvas) {
          const layer = this.getLayer(), canvas = can || layer && layer.getCanvas(), context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedSceneCanvas = cachedCanvas && cachedCanvas.scene;
          const caching = canvas && canvas.isCache;
          if (!this.isVisible() && !caching) {
            return this;
          }
          if (cachedSceneCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
          } else {
            this._drawChildren("drawScene", canvas, top, bufferCanvas);
          }
          return this;
        }
        drawHit(can, top) {
          if (!this.shouldDrawHit(top)) {
            return this;
          }
          const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas, context = canvas && canvas.getContext(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
          if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
          } else {
            this._drawChildren("drawHit", canvas, top);
          }
          return this;
        }
        _drawChildren(drawMethod, canvas, top, bufferCanvas) {
          var _a;
          const context = canvas && canvas.getContext(), clipWidth = this.clipWidth(), clipHeight = this.clipHeight(), clipFunc = this.clipFunc(), hasClip = typeof clipWidth === "number" && typeof clipHeight === "number" || clipFunc;
          const selfCache = top === this;
          if (hasClip) {
            context.save();
            const transform = this.getAbsoluteTransform(top);
            let m = transform.getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            context.beginPath();
            let clipArgs;
            if (clipFunc) {
              clipArgs = clipFunc.call(this, context, this);
            } else {
              const clipX = this.clipX();
              const clipY = this.clipY();
              context.rect(clipX || 0, clipY || 0, clipWidth, clipHeight);
            }
            context.clip.apply(context, clipArgs);
            m = transform.copy().invert().getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
          }
          const hasComposition = !selfCache && this.globalCompositeOperation() !== "source-over" && drawMethod === "drawScene";
          if (hasComposition) {
            context.save();
            context._applyGlobalCompositeOperation(this);
          }
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
            child[drawMethod](canvas, top, bufferCanvas);
          });
          if (hasComposition) {
            context.restore();
          }
          if (hasClip) {
            context.restore();
          }
        }
        getClientRect(config = {}) {
          var _a;
          const skipTransform = config.skipTransform;
          const relativeTo = config.relativeTo;
          let minX, minY, maxX, maxY;
          let selfRect = {
            x: Infinity,
            y: Infinity,
            width: 0,
            height: 0
          };
          const that = this;
          (_a = this.children) === null || _a === void 0 ? void 0 : _a.forEach(function(child) {
            if (!child.visible()) {
              return;
            }
            const rect = child.getClientRect({
              relativeTo: that,
              skipShadow: config.skipShadow,
              skipStroke: config.skipStroke
            });
            if (rect.width === 0 && rect.height === 0) {
              return;
            }
            if (minX === void 0) {
              minX = rect.x;
              minY = rect.y;
              maxX = rect.x + rect.width;
              maxY = rect.y + rect.height;
            } else {
              minX = Math.min(minX, rect.x);
              minY = Math.min(minY, rect.y);
              maxX = Math.max(maxX, rect.x + rect.width);
              maxY = Math.max(maxY, rect.y + rect.height);
            }
          });
          const shapes2 = this.find("Shape");
          let hasVisible = false;
          for (let i = 0; i < shapes2.length; i++) {
            const shape = shapes2[i];
            if (shape._isVisible(this)) {
              hasVisible = true;
              break;
            }
          }
          if (hasVisible && minX !== void 0) {
            selfRect = {
              x: minX,
              y: minY,
              width: maxX - minX,
              height: maxY - minY
            };
          } else {
            selfRect = {
              x: 0,
              y: 0,
              width: 0,
              height: 0
            };
          }
          if (!skipTransform) {
            return this._transformedRect(selfRect, relativeTo);
          }
          return selfRect;
        }
      }
      Factory.addComponentsGetterSetter(Container, "clip", [
        "x",
        "y",
        "width",
        "height"
      ]);
      Factory.addGetterSetter(Container, "clipX", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipY", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipWidth", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipHeight", void 0, getNumberValidator());
      Factory.addGetterSetter(Container, "clipFunc");
      const Captures = /* @__PURE__ */ new Map();
      const SUPPORT_POINTER_EVENTS = Konva._global["PointerEvent"] !== void 0;
      function getCapturedShape(pointerId) {
        return Captures.get(pointerId);
      }
      function createEvent(evt) {
        return {
          evt,
          pointerId: evt.pointerId
        };
      }
      function hasPointerCapture(pointerId, shape) {
        return Captures.get(pointerId) === shape;
      }
      function setPointerCapture(pointerId, shape) {
        releaseCapture(pointerId);
        const stage = shape.getStage();
        if (!stage)
          return;
        Captures.set(pointerId, shape);
        if (SUPPORT_POINTER_EVENTS) {
          shape._fire("gotpointercapture", createEvent(new PointerEvent("gotpointercapture")));
        }
      }
      function releaseCapture(pointerId, target) {
        const shape = Captures.get(pointerId);
        if (!shape)
          return;
        const stage = shape.getStage();
        if (stage && stage.content) ;
        Captures.delete(pointerId);
        if (SUPPORT_POINTER_EVENTS) {
          shape._fire("lostpointercapture", createEvent(new PointerEvent("lostpointercapture")));
        }
      }
      const STAGE = "Stage", STRING = "string", PX = "px", MOUSEOUT = "mouseout", MOUSELEAVE = "mouseleave", MOUSEOVER = "mouseover", MOUSEENTER = "mouseenter", MOUSEMOVE = "mousemove", MOUSEDOWN = "mousedown", MOUSEUP = "mouseup", POINTERMOVE = "pointermove", POINTERDOWN = "pointerdown", POINTERUP = "pointerup", POINTERCANCEL = "pointercancel", LOSTPOINTERCAPTURE = "lostpointercapture", POINTEROUT = "pointerout", POINTERLEAVE = "pointerleave", POINTEROVER = "pointerover", POINTERENTER = "pointerenter", CONTEXTMENU = "contextmenu", TOUCHSTART = "touchstart", TOUCHEND = "touchend", TOUCHMOVE = "touchmove", TOUCHCANCEL = "touchcancel", WHEEL = "wheel", MAX_LAYERS_NUMBER = 5, EVENTS = [
        [MOUSEENTER, "_pointerenter"],
        [MOUSEDOWN, "_pointerdown"],
        [MOUSEMOVE, "_pointermove"],
        [MOUSEUP, "_pointerup"],
        [MOUSELEAVE, "_pointerleave"],
        [TOUCHSTART, "_pointerdown"],
        [TOUCHMOVE, "_pointermove"],
        [TOUCHEND, "_pointerup"],
        [TOUCHCANCEL, "_pointercancel"],
        [MOUSEOVER, "_pointerover"],
        [WHEEL, "_wheel"],
        [CONTEXTMENU, "_contextmenu"],
        [POINTERDOWN, "_pointerdown"],
        [POINTERMOVE, "_pointermove"],
        [POINTERUP, "_pointerup"],
        [POINTERCANCEL, "_pointercancel"],
        [POINTERLEAVE, "_pointerleave"],
        [LOSTPOINTERCAPTURE, "_lostpointercapture"]
      ];
      const EVENTS_MAP = {
        mouse: {
          [POINTEROUT]: MOUSEOUT,
          [POINTERLEAVE]: MOUSELEAVE,
          [POINTEROVER]: MOUSEOVER,
          [POINTERENTER]: MOUSEENTER,
          [POINTERMOVE]: MOUSEMOVE,
          [POINTERDOWN]: MOUSEDOWN,
          [POINTERUP]: MOUSEUP,
          [POINTERCANCEL]: "mousecancel",
          pointerclick: "click",
          pointerdblclick: "dblclick"
        },
        touch: {
          [POINTEROUT]: "touchout",
          [POINTERLEAVE]: "touchleave",
          [POINTEROVER]: "touchover",
          [POINTERENTER]: "touchenter",
          [POINTERMOVE]: TOUCHMOVE,
          [POINTERDOWN]: TOUCHSTART,
          [POINTERUP]: TOUCHEND,
          [POINTERCANCEL]: TOUCHCANCEL,
          pointerclick: "tap",
          pointerdblclick: "dbltap"
        },
        pointer: {
          [POINTEROUT]: POINTEROUT,
          [POINTERLEAVE]: POINTERLEAVE,
          [POINTEROVER]: POINTEROVER,
          [POINTERENTER]: POINTERENTER,
          [POINTERMOVE]: POINTERMOVE,
          [POINTERDOWN]: POINTERDOWN,
          [POINTERUP]: POINTERUP,
          [POINTERCANCEL]: POINTERCANCEL,
          pointerclick: "pointerclick",
          pointerdblclick: "pointerdblclick"
        }
      };
      const getEventType = (type) => {
        if (type.indexOf("pointer") >= 0) {
          return "pointer";
        }
        if (type.indexOf("touch") >= 0) {
          return "touch";
        }
        return "mouse";
      };
      const getEventsMap = (eventType) => {
        const type = getEventType(eventType);
        if (type === "pointer") {
          return Konva.pointerEventsEnabled && EVENTS_MAP.pointer;
        }
        if (type === "touch") {
          return EVENTS_MAP.touch;
        }
        if (type === "mouse") {
          return EVENTS_MAP.mouse;
        }
      };
      function checkNoClip(attrs = {}) {
        if (attrs.clipFunc || attrs.clipWidth || attrs.clipHeight) {
          Util.warn("Stage does not support clipping. Please use clip for Layers or Groups.");
        }
        return attrs;
      }
      const NO_POINTERS_MESSAGE = `Pointer position is missing and not registered by the stage. Looks like it is outside of the stage container. You can set it manually from event: stage.setPointersPositions(event);`;
      const stages = [];
      class Stage extends Container {
        constructor(config) {
          super(checkNoClip(config));
          this._pointerPositions = [];
          this._changedPointerPositions = [];
          this._buildDOM();
          this._bindContentEvents();
          stages.push(this);
          this.on("widthChange.konva heightChange.konva", this._resizeDOM);
          this.on("visibleChange.konva", this._checkVisibility);
          this.on("clipWidthChange.konva clipHeightChange.konva clipFuncChange.konva", () => {
            checkNoClip(this.attrs);
          });
          this._checkVisibility();
        }
        _validateAdd(child) {
          const isLayer = child.getType() === "Layer";
          const isFastLayer = child.getType() === "FastLayer";
          const valid = isLayer || isFastLayer;
          if (!valid) {
            Util.throw("You may only add layers to the stage.");
          }
        }
        _checkVisibility() {
          if (!this.content) {
            return;
          }
          const style = this.visible() ? "" : "none";
          this.content.style.display = style;
        }
        setContainer(container) {
          if (typeof container === STRING) {
            let id;
            if (container.charAt(0) === ".") {
              const className = container.slice(1);
              container = document.getElementsByClassName(className)[0];
            } else {
              if (container.charAt(0) !== "#") {
                id = container;
              } else {
                id = container.slice(1);
              }
              container = document.getElementById(id);
            }
            if (!container) {
              throw "Can not find container in document with id " + id;
            }
          }
          this._setAttr("container", container);
          if (this.content) {
            if (this.content.parentElement) {
              this.content.parentElement.removeChild(this.content);
            }
            container.appendChild(this.content);
          }
          return this;
        }
        shouldDrawHit() {
          return true;
        }
        clear() {
          const layers = this.children, len = layers.length;
          for (let n = 0; n < len; n++) {
            layers[n].clear();
          }
          return this;
        }
        clone(obj) {
          if (!obj) {
            obj = {};
          }
          obj.container = typeof document !== "undefined" && document.createElement("div");
          return Container.prototype.clone.call(this, obj);
        }
        destroy() {
          super.destroy();
          const content = this.content;
          if (content && Util._isInDocument(content)) {
            this.container().removeChild(content);
          }
          const index = stages.indexOf(this);
          if (index > -1) {
            stages.splice(index, 1);
          }
          Util.releaseCanvas(this.bufferCanvas._canvas, this.bufferHitCanvas._canvas);
          return this;
        }
        getPointerPosition() {
          const pos = this._pointerPositions[0] || this._changedPointerPositions[0];
          if (!pos) {
            Util.warn(NO_POINTERS_MESSAGE);
            return null;
          }
          return {
            x: pos.x,
            y: pos.y
          };
        }
        _getPointerById(id) {
          return this._pointerPositions.find((p) => p.id === id);
        }
        getPointersPositions() {
          return this._pointerPositions;
        }
        getStage() {
          return this;
        }
        getContent() {
          return this.content;
        }
        _toKonvaCanvas(config) {
          config = config || {};
          config.x = config.x || 0;
          config.y = config.y || 0;
          config.width = config.width || this.width();
          config.height = config.height || this.height();
          const canvas = new SceneCanvas({
            width: config.width,
            height: config.height,
            pixelRatio: config.pixelRatio || 1
          });
          const _context = canvas.getContext()._context;
          const layers = this.children;
          if (config.x || config.y) {
            _context.translate(-1 * config.x, -1 * config.y);
          }
          layers.forEach(function(layer) {
            if (!layer.isVisible()) {
              return;
            }
            const layerCanvas = layer._toKonvaCanvas(config);
            _context.drawImage(layerCanvas._canvas, config.x, config.y, layerCanvas.getWidth() / layerCanvas.getPixelRatio(), layerCanvas.getHeight() / layerCanvas.getPixelRatio());
          });
          return canvas;
        }
        getIntersection(pos) {
          if (!pos) {
            return null;
          }
          const layers = this.children, len = layers.length, end = len - 1;
          for (let n = end; n >= 0; n--) {
            const shape = layers[n].getIntersection(pos);
            if (shape) {
              return shape;
            }
          }
          return null;
        }
        _resizeDOM() {
          const width = this.width();
          const height = this.height();
          if (this.content) {
            this.content.style.width = width + PX;
            this.content.style.height = height + PX;
          }
          this.bufferCanvas.setSize(width, height);
          this.bufferHitCanvas.setSize(width, height);
          this.children.forEach((layer) => {
            layer.setSize({ width, height });
            layer.draw();
          });
        }
        add(layer, ...rest) {
          if (arguments.length > 1) {
            for (let i = 0; i < arguments.length; i++) {
              this.add(arguments[i]);
            }
            return this;
          }
          super.add(layer);
          const length = this.children.length;
          if (length > MAX_LAYERS_NUMBER) {
            Util.warn("The stage has " + length + " layers. Recommended maximum number of layers is 3-5. Adding more layers into the stage may drop the performance. Rethink your tree structure, you can use Konva.Group.");
          }
          layer.setSize({ width: this.width(), height: this.height() });
          layer.draw();
          if (Konva.isBrowser) {
            this.content.appendChild(layer.canvas._canvas);
          }
          return this;
        }
        getParent() {
          return null;
        }
        getLayer() {
          return null;
        }
        hasPointerCapture(pointerId) {
          return hasPointerCapture(pointerId, this);
        }
        setPointerCapture(pointerId) {
          setPointerCapture(pointerId, this);
        }
        releaseCapture(pointerId) {
          releaseCapture(pointerId);
        }
        getLayers() {
          return this.children;
        }
        _bindContentEvents() {
          if (!Konva.isBrowser) {
            return;
          }
          EVENTS.forEach(([event, methodName]) => {
            this.content.addEventListener(event, (evt) => {
              this[methodName](evt);
            }, { passive: false });
          });
        }
        _pointerenter(evt) {
          this.setPointersPositions(evt);
          const events = getEventsMap(evt.type);
          if (events) {
            this._fire(events.pointerenter, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _pointerover(evt) {
          this.setPointersPositions(evt);
          const events = getEventsMap(evt.type);
          if (events) {
            this._fire(events.pointerover, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _getTargetShape(evenType) {
          let shape = this[evenType + "targetShape"];
          if (shape && !shape.getStage()) {
            shape = null;
          }
          return shape;
        }
        _pointerleave(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          this.setPointersPositions(evt);
          const targetShape = this._getTargetShape(eventType);
          const eventsEnabled = !(Konva.isDragging() || Konva.isTransforming()) || Konva.hitOnDragEnabled;
          if (targetShape && eventsEnabled) {
            targetShape._fireAndBubble(events.pointerout, { evt });
            targetShape._fireAndBubble(events.pointerleave, { evt });
            this._fire(events.pointerleave, {
              evt,
              target: this,
              currentTarget: this
            });
            this[eventType + "targetShape"] = null;
          } else if (eventsEnabled) {
            this._fire(events.pointerleave, {
              evt,
              target: this,
              currentTarget: this
            });
            this._fire(events.pointerout, {
              evt,
              target: this,
              currentTarget: this
            });
          }
          this.pointerPos = null;
          this._pointerPositions = [];
        }
        _pointerdown(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          this.setPointersPositions(evt);
          let triggeredOnShape = false;
          this._changedPointerPositions.forEach((pos) => {
            const shape = this.getIntersection(pos);
            DD.justDragged = false;
            Konva["_" + eventType + "ListenClick"] = true;
            if (!shape || !shape.isListening()) {
              this[eventType + "ClickStartShape"] = void 0;
              return;
            }
            if (Konva.capturePointerEventsEnabled) {
              shape.setPointerCapture(pos.id);
            }
            this[eventType + "ClickStartShape"] = shape;
            shape._fireAndBubble(events.pointerdown, {
              evt,
              pointerId: pos.id
            });
            triggeredOnShape = true;
            const isTouch = evt.type.indexOf("touch") >= 0;
            if (shape.preventDefault() && evt.cancelable && isTouch) {
              evt.preventDefault();
            }
          });
          if (!triggeredOnShape) {
            this._fire(events.pointerdown, {
              evt,
              target: this,
              currentTarget: this,
              pointerId: this._pointerPositions[0].id
            });
          }
        }
        _pointermove(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          if (Konva.isDragging() && DD.node.preventDefault() && evt.cancelable) {
            evt.preventDefault();
          }
          this.setPointersPositions(evt);
          const eventsEnabled = !(Konva.isDragging() || Konva.isTransforming()) || Konva.hitOnDragEnabled;
          if (!eventsEnabled) {
            return;
          }
          const processedShapesIds = {};
          let triggeredOnShape = false;
          const targetShape = this._getTargetShape(eventType);
          this._changedPointerPositions.forEach((pos) => {
            const shape = getCapturedShape(pos.id) || this.getIntersection(pos);
            const pointerId = pos.id;
            const event = { evt, pointerId };
            const differentTarget = targetShape !== shape;
            if (differentTarget && targetShape) {
              targetShape._fireAndBubble(events.pointerout, { ...event }, shape);
              targetShape._fireAndBubble(events.pointerleave, { ...event }, shape);
            }
            if (shape) {
              if (processedShapesIds[shape._id]) {
                return;
              }
              processedShapesIds[shape._id] = true;
            }
            if (shape && shape.isListening()) {
              triggeredOnShape = true;
              if (differentTarget) {
                shape._fireAndBubble(events.pointerover, { ...event }, targetShape);
                shape._fireAndBubble(events.pointerenter, { ...event }, targetShape);
                this[eventType + "targetShape"] = shape;
              }
              shape._fireAndBubble(events.pointermove, { ...event });
            } else {
              if (targetShape) {
                this._fire(events.pointerover, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId
                });
                this[eventType + "targetShape"] = null;
              }
            }
          });
          if (!triggeredOnShape) {
            this._fire(events.pointermove, {
              evt,
              target: this,
              currentTarget: this,
              pointerId: this._changedPointerPositions[0].id
            });
          }
        }
        _pointerup(evt) {
          const events = getEventsMap(evt.type);
          const eventType = getEventType(evt.type);
          if (!events) {
            return;
          }
          this.setPointersPositions(evt);
          const clickStartShape = this[eventType + "ClickStartShape"];
          const clickEndShape = this[eventType + "ClickEndShape"];
          const processedShapesIds = {};
          let triggeredOnShape = false;
          this._changedPointerPositions.forEach((pos) => {
            const shape = getCapturedShape(pos.id) || this.getIntersection(pos);
            if (shape) {
              shape.releaseCapture(pos.id);
              if (processedShapesIds[shape._id]) {
                return;
              }
              processedShapesIds[shape._id] = true;
            }
            const pointerId = pos.id;
            const event = { evt, pointerId };
            let fireDblClick = false;
            if (Konva["_" + eventType + "InDblClickWindow"]) {
              fireDblClick = true;
              clearTimeout(this[eventType + "DblTimeout"]);
            } else if (!DD.justDragged) {
              Konva["_" + eventType + "InDblClickWindow"] = true;
              clearTimeout(this[eventType + "DblTimeout"]);
            }
            this[eventType + "DblTimeout"] = setTimeout(function() {
              Konva["_" + eventType + "InDblClickWindow"] = false;
            }, Konva.dblClickWindow);
            if (shape && shape.isListening()) {
              triggeredOnShape = true;
              this[eventType + "ClickEndShape"] = shape;
              shape._fireAndBubble(events.pointerup, { ...event });
              if (Konva["_" + eventType + "ListenClick"] && clickStartShape && clickStartShape === shape) {
                shape._fireAndBubble(events.pointerclick, { ...event });
                if (fireDblClick && clickEndShape && clickEndShape === shape) {
                  shape._fireAndBubble(events.pointerdblclick, { ...event });
                }
              }
            } else {
              this[eventType + "ClickEndShape"] = null;
              if (Konva["_" + eventType + "ListenClick"]) {
                this._fire(events.pointerclick, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId
                });
              }
              if (fireDblClick) {
                this._fire(events.pointerdblclick, {
                  evt,
                  target: this,
                  currentTarget: this,
                  pointerId
                });
              }
            }
          });
          if (!triggeredOnShape) {
            this._fire(events.pointerup, {
              evt,
              target: this,
              currentTarget: this,
              pointerId: this._changedPointerPositions[0].id
            });
          }
          Konva["_" + eventType + "ListenClick"] = false;
          if (evt.cancelable && eventType !== "touch" && eventType !== "pointer") {
            evt.preventDefault();
          }
        }
        _contextmenu(evt) {
          this.setPointersPositions(evt);
          const shape = this.getIntersection(this.getPointerPosition());
          if (shape && shape.isListening()) {
            shape._fireAndBubble(CONTEXTMENU, { evt });
          } else {
            this._fire(CONTEXTMENU, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _wheel(evt) {
          this.setPointersPositions(evt);
          const shape = this.getIntersection(this.getPointerPosition());
          if (shape && shape.isListening()) {
            shape._fireAndBubble(WHEEL, { evt });
          } else {
            this._fire(WHEEL, {
              evt,
              target: this,
              currentTarget: this
            });
          }
        }
        _pointercancel(evt) {
          this.setPointersPositions(evt);
          const shape = getCapturedShape(evt.pointerId) || this.getIntersection(this.getPointerPosition());
          if (shape) {
            shape._fireAndBubble(POINTERUP, createEvent(evt));
          }
          releaseCapture(evt.pointerId);
        }
        _lostpointercapture(evt) {
          releaseCapture(evt.pointerId);
        }
        setPointersPositions(evt) {
          const contentPosition = this._getContentPosition();
          let x = null, y = null;
          evt = evt ? evt : window.event;
          if (evt.touches !== void 0) {
            this._pointerPositions = [];
            this._changedPointerPositions = [];
            Array.prototype.forEach.call(evt.touches, (touch) => {
              this._pointerPositions.push({
                id: touch.identifier,
                x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
              });
            });
            Array.prototype.forEach.call(evt.changedTouches || evt.touches, (touch) => {
              this._changedPointerPositions.push({
                id: touch.identifier,
                x: (touch.clientX - contentPosition.left) / contentPosition.scaleX,
                y: (touch.clientY - contentPosition.top) / contentPosition.scaleY
              });
            });
          } else {
            x = (evt.clientX - contentPosition.left) / contentPosition.scaleX;
            y = (evt.clientY - contentPosition.top) / contentPosition.scaleY;
            this.pointerPos = {
              x,
              y
            };
            this._pointerPositions = [{ x, y, id: Util._getFirstPointerId(evt) }];
            this._changedPointerPositions = [
              { x, y, id: Util._getFirstPointerId(evt) }
            ];
          }
        }
        _setPointerPosition(evt) {
          Util.warn('Method _setPointerPosition is deprecated. Use "stage.setPointersPositions(event)" instead.');
          this.setPointersPositions(evt);
        }
        _getContentPosition() {
          if (!this.content || !this.content.getBoundingClientRect) {
            return {
              top: 0,
              left: 0,
              scaleX: 1,
              scaleY: 1
            };
          }
          const rect = this.content.getBoundingClientRect();
          return {
            top: rect.top,
            left: rect.left,
            scaleX: rect.width / this.content.clientWidth || 1,
            scaleY: rect.height / this.content.clientHeight || 1
          };
        }
        _buildDOM() {
          this.bufferCanvas = new SceneCanvas({
            width: this.width(),
            height: this.height()
          });
          this.bufferHitCanvas = new HitCanvas({
            pixelRatio: 1,
            width: this.width(),
            height: this.height()
          });
          if (!Konva.isBrowser) {
            return;
          }
          const container = this.container();
          if (!container) {
            throw "Stage has no container. A container is required.";
          }
          container.innerHTML = "";
          this.content = document.createElement("div");
          this.content.style.position = "relative";
          this.content.style.userSelect = "none";
          this.content.className = "konvajs-content";
          this.content.setAttribute("role", "presentation");
          container.appendChild(this.content);
          this._resizeDOM();
        }
        cache() {
          Util.warn("Cache function is not allowed for stage. You may use cache only for layers, groups and shapes.");
          return this;
        }
        clearCache() {
          return this;
        }
        batchDraw() {
          this.getChildren().forEach(function(layer) {
            layer.batchDraw();
          });
          return this;
        }
      }
      Stage.prototype.nodeType = STAGE;
      _registerNode(Stage);
      Factory.addGetterSetter(Stage, "container");
      if (Konva.isBrowser) {
        document.addEventListener("visibilitychange", () => {
          stages.forEach((stage) => {
            stage.batchDraw();
          });
        });
      }
      class Group extends Container {
        _validateAdd(child) {
          const type = child.getType();
          if (type !== "Group" && type !== "Shape") {
            Util.throw("You may only add groups and shapes to groups.");
          }
        }
      }
      Group.prototype.nodeType = "Group";
      _registerNode(Group);
      const HAS_SHADOW = "hasShadow";
      const SHADOW_RGBA = "shadowRGBA";
      const patternImage = "patternImage";
      const linearGradient = "linearGradient";
      const radialGradient = "radialGradient";
      let dummyContext;
      function getDummyContext() {
        if (dummyContext) {
          return dummyContext;
        }
        dummyContext = Util.createCanvasElement().getContext("2d");
        return dummyContext;
      }
      const shapes = {};
      function _fillFunc(context) {
        const fillRule = this.attrs.fillRule;
        if (fillRule) {
          context.fill(fillRule);
        } else {
          context.fill();
        }
      }
      function _strokeFunc(context) {
        context.stroke();
      }
      function _fillFuncHit(context) {
        const fillRule = this.attrs.fillRule;
        if (fillRule) {
          context.fill(fillRule);
        } else {
          context.fill();
        }
      }
      function _strokeFuncHit(context) {
        context.stroke();
      }
      function _clearHasShadowCache() {
        this._clearCache(HAS_SHADOW);
      }
      function _clearGetShadowRGBACache() {
        this._clearCache(SHADOW_RGBA);
      }
      function _clearFillPatternCache() {
        this._clearCache(patternImage);
      }
      function _clearLinearGradientCache() {
        this._clearCache(linearGradient);
      }
      function _clearRadialGradientCache() {
        this._clearCache(radialGradient);
      }
      class Shape extends Node {
        constructor(config) {
          super(config);
          let key;
          while (true) {
            key = Util.getRandomColor();
            if (key && !(key in shapes)) {
              break;
            }
          }
          this.colorKey = key;
          shapes[key] = this;
        }
        getContext() {
          Util.warn("shape.getContext() method is deprecated. Please do not use it.");
          return this.getLayer().getContext();
        }
        getCanvas() {
          Util.warn("shape.getCanvas() method is deprecated. Please do not use it.");
          return this.getLayer().getCanvas();
        }
        getSceneFunc() {
          return this.attrs.sceneFunc || this["_sceneFunc"];
        }
        getHitFunc() {
          return this.attrs.hitFunc || this["_hitFunc"];
        }
        hasShadow() {
          return this._getCache(HAS_SHADOW, this._hasShadow);
        }
        _hasShadow() {
          return this.shadowEnabled() && this.shadowOpacity() !== 0 && !!(this.shadowColor() || this.shadowBlur() || this.shadowOffsetX() || this.shadowOffsetY());
        }
        _getFillPattern() {
          return this._getCache(patternImage, this.__getFillPattern);
        }
        __getFillPattern() {
          if (this.fillPatternImage()) {
            const ctx = getDummyContext();
            const pattern = ctx.createPattern(this.fillPatternImage(), this.fillPatternRepeat() || "repeat");
            if (pattern && pattern.setTransform) {
              const tr = new Transform();
              tr.translate(this.fillPatternX(), this.fillPatternY());
              tr.rotate(Konva.getAngle(this.fillPatternRotation()));
              tr.scale(this.fillPatternScaleX(), this.fillPatternScaleY());
              tr.translate(-1 * this.fillPatternOffsetX(), -1 * this.fillPatternOffsetY());
              const m = tr.getMatrix();
              const matrix = typeof DOMMatrix === "undefined" ? {
                a: m[0],
                b: m[1],
                c: m[2],
                d: m[3],
                e: m[4],
                f: m[5]
              } : new DOMMatrix(m);
              pattern.setTransform(matrix);
            }
            return pattern;
          }
        }
        _getLinearGradient() {
          return this._getCache(linearGradient, this.__getLinearGradient);
        }
        __getLinearGradient() {
          const colorStops = this.fillLinearGradientColorStops();
          if (colorStops) {
            const ctx = getDummyContext();
            const start = this.fillLinearGradientStartPoint();
            const end = this.fillLinearGradientEndPoint();
            const grd = ctx.createLinearGradient(start.x, start.y, end.x, end.y);
            for (let n = 0; n < colorStops.length; n += 2) {
              grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
          }
        }
        _getRadialGradient() {
          return this._getCache(radialGradient, this.__getRadialGradient);
        }
        __getRadialGradient() {
          const colorStops = this.fillRadialGradientColorStops();
          if (colorStops) {
            const ctx = getDummyContext();
            const start = this.fillRadialGradientStartPoint();
            const end = this.fillRadialGradientEndPoint();
            const grd = ctx.createRadialGradient(start.x, start.y, this.fillRadialGradientStartRadius(), end.x, end.y, this.fillRadialGradientEndRadius());
            for (let n = 0; n < colorStops.length; n += 2) {
              grd.addColorStop(colorStops[n], colorStops[n + 1]);
            }
            return grd;
          }
        }
        getShadowRGBA() {
          return this._getCache(SHADOW_RGBA, this._getShadowRGBA);
        }
        _getShadowRGBA() {
          if (!this.hasShadow()) {
            return;
          }
          const rgba = Util.colorToRGBA(this.shadowColor());
          if (rgba) {
            return "rgba(" + rgba.r + "," + rgba.g + "," + rgba.b + "," + rgba.a * (this.shadowOpacity() || 1) + ")";
          }
        }
        hasFill() {
          return this._calculate("hasFill", [
            "fillEnabled",
            "fill",
            "fillPatternImage",
            "fillLinearGradientColorStops",
            "fillRadialGradientColorStops"
          ], () => {
            return this.fillEnabled() && !!(this.fill() || this.fillPatternImage() || this.fillLinearGradientColorStops() || this.fillRadialGradientColorStops());
          });
        }
        hasStroke() {
          return this._calculate("hasStroke", [
            "strokeEnabled",
            "strokeWidth",
            "stroke",
            "strokeLinearGradientColorStops"
          ], () => {
            return this.strokeEnabled() && this.strokeWidth() && !!(this.stroke() || this.strokeLinearGradientColorStops());
          });
        }
        hasHitStroke() {
          const width = this.hitStrokeWidth();
          if (width === "auto") {
            return this.hasStroke();
          }
          return this.strokeEnabled() && !!width;
        }
        intersects(point) {
          const stage = this.getStage();
          if (!stage) {
            return false;
          }
          const bufferHitCanvas = stage.bufferHitCanvas;
          bufferHitCanvas.getContext().clear();
          this.drawHit(bufferHitCanvas, void 0, true);
          const p = bufferHitCanvas.context.getImageData(Math.round(point.x), Math.round(point.y), 1, 1).data;
          return p[3] > 0;
        }
        destroy() {
          Node.prototype.destroy.call(this);
          delete shapes[this.colorKey];
          delete this.colorKey;
          return this;
        }
        _useBufferCanvas(forceFill) {
          var _a;
          const perfectDrawEnabled = (_a = this.attrs.perfectDrawEnabled) !== null && _a !== void 0 ? _a : true;
          if (!perfectDrawEnabled) {
            return false;
          }
          const hasFill = forceFill || this.hasFill();
          const hasStroke = this.hasStroke();
          const isTransparent = this.getAbsoluteOpacity() !== 1;
          if (hasFill && hasStroke && isTransparent) {
            return true;
          }
          const hasShadow = this.hasShadow();
          const strokeForShadow = this.shadowForStrokeEnabled();
          if (hasFill && hasStroke && hasShadow && strokeForShadow) {
            return true;
          }
          return false;
        }
        setStrokeHitEnabled(val) {
          Util.warn("strokeHitEnabled property is deprecated. Please use hitStrokeWidth instead.");
          if (val) {
            this.hitStrokeWidth("auto");
          } else {
            this.hitStrokeWidth(0);
          }
        }
        getStrokeHitEnabled() {
          if (this.hitStrokeWidth() === 0) {
            return false;
          } else {
            return true;
          }
        }
        getSelfRect() {
          const size = this.size();
          return {
            x: this._centroid ? -size.width / 2 : 0,
            y: this._centroid ? -size.height / 2 : 0,
            width: size.width,
            height: size.height
          };
        }
        getClientRect(config = {}) {
          let hasCachedParent = false;
          let parent = this.getParent();
          while (parent) {
            if (parent.isCached()) {
              hasCachedParent = true;
              break;
            }
            parent = parent.getParent();
          }
          const skipTransform = config.skipTransform;
          const relativeTo = config.relativeTo || hasCachedParent && this.getStage() || void 0;
          const fillRect = this.getSelfRect();
          const applyStroke = !config.skipStroke && this.hasStroke();
          const strokeWidth = applyStroke && this.strokeWidth() || 0;
          const fillAndStrokeWidth = fillRect.width + strokeWidth;
          const fillAndStrokeHeight = fillRect.height + strokeWidth;
          const applyShadow = !config.skipShadow && this.hasShadow();
          const shadowOffsetX = applyShadow ? this.shadowOffsetX() : 0;
          const shadowOffsetY = applyShadow ? this.shadowOffsetY() : 0;
          const preWidth = fillAndStrokeWidth + Math.abs(shadowOffsetX);
          const preHeight = fillAndStrokeHeight + Math.abs(shadowOffsetY);
          const blurRadius = applyShadow && this.shadowBlur() || 0;
          const width = preWidth + blurRadius * 2;
          const height = preHeight + blurRadius * 2;
          const rect = {
            width,
            height,
            x: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetX, 0) + fillRect.x,
            y: -(strokeWidth / 2 + blurRadius) + Math.min(shadowOffsetY, 0) + fillRect.y
          };
          if (!skipTransform) {
            return this._transformedRect(rect, relativeTo);
          }
          return rect;
        }
        drawScene(can, top, bufferCanvas) {
          const layer = this.getLayer();
          const canvas = can || layer.getCanvas(), context = canvas.getContext(), cachedCanvas = this._getCanvasCache(), drawFunc = this.getSceneFunc(), hasShadow = this.hasShadow();
          let stage;
          const cachingSelf = top === this;
          if (!this.isVisible() && !cachingSelf) {
            return this;
          }
          if (cachedCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedSceneCanvas(context);
            context.restore();
            return this;
          }
          if (!drawFunc) {
            return this;
          }
          context.save();
          if (this._useBufferCanvas() && true) {
            stage = this.getStage();
            const bc = bufferCanvas || stage.bufferCanvas;
            const bufferContext = bc.getContext();
            bufferContext.clear();
            bufferContext.save();
            bufferContext._applyLineJoin(this);
            const o = this.getAbsoluteTransform(top).getMatrix();
            bufferContext.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
            drawFunc.call(this, bufferContext, this);
            bufferContext.restore();
            const ratio = bc.pixelRatio;
            if (hasShadow) {
              context._applyShadow(this);
            }
            context._applyOpacity(this);
            context._applyGlobalCompositeOperation(this);
            context.drawImage(bc._canvas, bc.x || 0, bc.y || 0, bc.width / ratio, bc.height / ratio);
          } else {
            context._applyLineJoin(this);
            if (!cachingSelf) {
              const o = this.getAbsoluteTransform(top).getMatrix();
              context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
              context._applyOpacity(this);
              context._applyGlobalCompositeOperation(this);
            }
            if (hasShadow) {
              context._applyShadow(this);
            }
            drawFunc.call(this, context, this);
          }
          context.restore();
          return this;
        }
        drawHit(can, top, skipDragCheck = false) {
          if (!this.shouldDrawHit(top, skipDragCheck)) {
            return this;
          }
          const layer = this.getLayer(), canvas = can || layer.hitCanvas, context = canvas && canvas.getContext(), drawFunc = this.hitFunc() || this.sceneFunc(), cachedCanvas = this._getCanvasCache(), cachedHitCanvas = cachedCanvas && cachedCanvas.hit;
          if (!this.colorKey) {
            Util.warn("Looks like your canvas has a destroyed shape in it. Do not reuse shape after you destroyed it. If you want to reuse shape you should call remove() instead of destroy()");
          }
          if (cachedHitCanvas) {
            context.save();
            const m = this.getAbsoluteTransform(top).getMatrix();
            context.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            this._drawCachedHitCanvas(context);
            context.restore();
            return this;
          }
          if (!drawFunc) {
            return this;
          }
          context.save();
          context._applyLineJoin(this);
          const selfCache = this === top;
          if (!selfCache) {
            const o = this.getAbsoluteTransform(top).getMatrix();
            context.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
          }
          drawFunc.call(this, context, this);
          context.restore();
          return this;
        }
        drawHitFromCache(alphaThreshold = 0) {
          const cachedCanvas = this._getCanvasCache(), sceneCanvas = this._getCachedSceneCanvas(), hitCanvas = cachedCanvas.hit, hitContext = hitCanvas.getContext(), hitWidth = hitCanvas.getWidth(), hitHeight = hitCanvas.getHeight();
          hitContext.clear();
          hitContext.drawImage(sceneCanvas._canvas, 0, 0, hitWidth, hitHeight);
          try {
            const hitImageData = hitContext.getImageData(0, 0, hitWidth, hitHeight);
            const hitData = hitImageData.data;
            const len = hitData.length;
            const rgbColorKey = Util._hexToRgb(this.colorKey);
            for (let i = 0; i < len; i += 4) {
              const alpha = hitData[i + 3];
              if (alpha > alphaThreshold) {
                hitData[i] = rgbColorKey.r;
                hitData[i + 1] = rgbColorKey.g;
                hitData[i + 2] = rgbColorKey.b;
                hitData[i + 3] = 255;
              } else {
                hitData[i + 3] = 0;
              }
            }
            hitContext.putImageData(hitImageData, 0, 0);
          } catch (e) {
            Util.error("Unable to draw hit graph from cached scene canvas. " + e.message);
          }
          return this;
        }
        hasPointerCapture(pointerId) {
          return hasPointerCapture(pointerId, this);
        }
        setPointerCapture(pointerId) {
          setPointerCapture(pointerId, this);
        }
        releaseCapture(pointerId) {
          releaseCapture(pointerId);
        }
      }
      Shape.prototype._fillFunc = _fillFunc;
      Shape.prototype._strokeFunc = _strokeFunc;
      Shape.prototype._fillFuncHit = _fillFuncHit;
      Shape.prototype._strokeFuncHit = _strokeFuncHit;
      Shape.prototype._centroid = false;
      Shape.prototype.nodeType = "Shape";
      _registerNode(Shape);
      Shape.prototype.eventListeners = {};
      Shape.prototype.on.call(Shape.prototype, "shadowColorChange.konva shadowBlurChange.konva shadowOffsetChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", _clearHasShadowCache);
      Shape.prototype.on.call(Shape.prototype, "shadowColorChange.konva shadowOpacityChange.konva shadowEnabledChange.konva", _clearGetShadowRGBACache);
      Shape.prototype.on.call(Shape.prototype, "fillPriorityChange.konva fillPatternImageChange.konva fillPatternRepeatChange.konva fillPatternScaleXChange.konva fillPatternScaleYChange.konva fillPatternOffsetXChange.konva fillPatternOffsetYChange.konva fillPatternXChange.konva fillPatternYChange.konva fillPatternRotationChange.konva", _clearFillPatternCache);
      Shape.prototype.on.call(Shape.prototype, "fillPriorityChange.konva fillLinearGradientColorStopsChange.konva fillLinearGradientStartPointXChange.konva fillLinearGradientStartPointYChange.konva fillLinearGradientEndPointXChange.konva fillLinearGradientEndPointYChange.konva", _clearLinearGradientCache);
      Shape.prototype.on.call(Shape.prototype, "fillPriorityChange.konva fillRadialGradientColorStopsChange.konva fillRadialGradientStartPointXChange.konva fillRadialGradientStartPointYChange.konva fillRadialGradientEndPointXChange.konva fillRadialGradientEndPointYChange.konva fillRadialGradientStartRadiusChange.konva fillRadialGradientEndRadiusChange.konva", _clearRadialGradientCache);
      Factory.addGetterSetter(Shape, "stroke", void 0, getStringOrGradientValidator());
      Factory.addGetterSetter(Shape, "strokeWidth", 2, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillAfterStrokeEnabled", false);
      Factory.addGetterSetter(Shape, "hitStrokeWidth", "auto", getNumberOrAutoValidator());
      Factory.addGetterSetter(Shape, "strokeHitEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Shape, "perfectDrawEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Shape, "shadowForStrokeEnabled", true, getBooleanValidator());
      Factory.addGetterSetter(Shape, "lineJoin");
      Factory.addGetterSetter(Shape, "lineCap");
      Factory.addGetterSetter(Shape, "sceneFunc");
      Factory.addGetterSetter(Shape, "hitFunc");
      Factory.addGetterSetter(Shape, "dash");
      Factory.addGetterSetter(Shape, "dashOffset", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "shadowColor", void 0, getStringValidator());
      Factory.addGetterSetter(Shape, "shadowBlur", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "shadowOpacity", 1, getNumberValidator());
      Factory.addComponentsGetterSetter(Shape, "shadowOffset", ["x", "y"]);
      Factory.addGetterSetter(Shape, "shadowOffsetX", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "shadowOffsetY", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternImage");
      Factory.addGetterSetter(Shape, "fill", void 0, getStringOrGradientValidator());
      Factory.addGetterSetter(Shape, "fillPatternX", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternY", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillLinearGradientColorStops");
      Factory.addGetterSetter(Shape, "strokeLinearGradientColorStops");
      Factory.addGetterSetter(Shape, "fillRadialGradientStartRadius", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientEndRadius", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientColorStops");
      Factory.addGetterSetter(Shape, "fillPatternRepeat", "repeat");
      Factory.addGetterSetter(Shape, "fillEnabled", true);
      Factory.addGetterSetter(Shape, "strokeEnabled", true);
      Factory.addGetterSetter(Shape, "shadowEnabled", true);
      Factory.addGetterSetter(Shape, "dashEnabled", true);
      Factory.addGetterSetter(Shape, "strokeScaleEnabled", true);
      Factory.addGetterSetter(Shape, "fillPriority", "color");
      Factory.addComponentsGetterSetter(Shape, "fillPatternOffset", ["x", "y"]);
      Factory.addGetterSetter(Shape, "fillPatternOffsetX", 0, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternOffsetY", 0, getNumberValidator());
      Factory.addComponentsGetterSetter(Shape, "fillPatternScale", ["x", "y"]);
      Factory.addGetterSetter(Shape, "fillPatternScaleX", 1, getNumberValidator());
      Factory.addGetterSetter(Shape, "fillPatternScaleY", 1, getNumberValidator());
      Factory.addComponentsGetterSetter(Shape, "fillLinearGradientStartPoint", [
        "x",
        "y"
      ]);
      Factory.addComponentsGetterSetter(Shape, "strokeLinearGradientStartPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillLinearGradientStartPointX", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientStartPointX", 0);
      Factory.addGetterSetter(Shape, "fillLinearGradientStartPointY", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientStartPointY", 0);
      Factory.addComponentsGetterSetter(Shape, "fillLinearGradientEndPoint", [
        "x",
        "y"
      ]);
      Factory.addComponentsGetterSetter(Shape, "strokeLinearGradientEndPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillLinearGradientEndPointX", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientEndPointX", 0);
      Factory.addGetterSetter(Shape, "fillLinearGradientEndPointY", 0);
      Factory.addGetterSetter(Shape, "strokeLinearGradientEndPointY", 0);
      Factory.addComponentsGetterSetter(Shape, "fillRadialGradientStartPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillRadialGradientStartPointX", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientStartPointY", 0);
      Factory.addComponentsGetterSetter(Shape, "fillRadialGradientEndPoint", [
        "x",
        "y"
      ]);
      Factory.addGetterSetter(Shape, "fillRadialGradientEndPointX", 0);
      Factory.addGetterSetter(Shape, "fillRadialGradientEndPointY", 0);
      Factory.addGetterSetter(Shape, "fillPatternRotation", 0);
      Factory.addGetterSetter(Shape, "fillRule", void 0, getStringValidator());
      Factory.backCompat(Shape, {
        dashArray: "dash",
        getDashArray: "getDash",
        setDashArray: "getDash",
        drawFunc: "sceneFunc",
        getDrawFunc: "getSceneFunc",
        setDrawFunc: "setSceneFunc",
        drawHitFunc: "hitFunc",
        getDrawHitFunc: "getHitFunc",
        setDrawHitFunc: "setHitFunc"
      });
      const HASH = "#", BEFORE_DRAW = "beforeDraw", DRAW = "draw", INTERSECTION_OFFSETS = [
        { x: 0, y: 0 },
        { x: -1, y: -1 },
        { x: 1, y: -1 },
        { x: 1, y: 1 },
        { x: -1, y: 1 }
      ], INTERSECTION_OFFSETS_LEN = INTERSECTION_OFFSETS.length;
      class Layer extends Container {
        constructor(config) {
          super(config);
          this.canvas = new SceneCanvas();
          this.hitCanvas = new HitCanvas({
            pixelRatio: 1
          });
          this._waitingForDraw = false;
          this.on("visibleChange.konva", this._checkVisibility);
          this._checkVisibility();
          this.on("imageSmoothingEnabledChange.konva", this._setSmoothEnabled);
          this._setSmoothEnabled();
        }
        createPNGStream() {
          const c = this.canvas._canvas;
          return c.createPNGStream();
        }
        getCanvas() {
          return this.canvas;
        }
        getNativeCanvasElement() {
          return this.canvas._canvas;
        }
        getHitCanvas() {
          return this.hitCanvas;
        }
        getContext() {
          return this.getCanvas().getContext();
        }
        clear(bounds) {
          this.getContext().clear(bounds);
          this.getHitCanvas().getContext().clear(bounds);
          return this;
        }
        setZIndex(index) {
          super.setZIndex(index);
          const stage = this.getStage();
          if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            if (index < stage.children.length - 1) {
              stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[index + 1].getCanvas()._canvas);
            } else {
              stage.content.appendChild(this.getNativeCanvasElement());
            }
          }
          return this;
        }
        moveToTop() {
          Node.prototype.moveToTop.call(this);
          const stage = this.getStage();
          if (stage && stage.content) {
            stage.content.removeChild(this.getNativeCanvasElement());
            stage.content.appendChild(this.getNativeCanvasElement());
          }
          return true;
        }
        moveUp() {
          const moved = Node.prototype.moveUp.call(this);
          if (!moved) {
            return false;
          }
          const stage = this.getStage();
          if (!stage || !stage.content) {
            return false;
          }
          stage.content.removeChild(this.getNativeCanvasElement());
          if (this.index < stage.children.length - 1) {
            stage.content.insertBefore(this.getNativeCanvasElement(), stage.children[this.index + 1].getCanvas()._canvas);
          } else {
            stage.content.appendChild(this.getNativeCanvasElement());
          }
          return true;
        }
        moveDown() {
          if (Node.prototype.moveDown.call(this)) {
            const stage = this.getStage();
            if (stage) {
              const children = stage.children;
              if (stage.content) {
                stage.content.removeChild(this.getNativeCanvasElement());
                stage.content.insertBefore(this.getNativeCanvasElement(), children[this.index + 1].getCanvas()._canvas);
              }
            }
            return true;
          }
          return false;
        }
        moveToBottom() {
          if (Node.prototype.moveToBottom.call(this)) {
            const stage = this.getStage();
            if (stage) {
              const children = stage.children;
              if (stage.content) {
                stage.content.removeChild(this.getNativeCanvasElement());
                stage.content.insertBefore(this.getNativeCanvasElement(), children[1].getCanvas()._canvas);
              }
            }
            return true;
          }
          return false;
        }
        getLayer() {
          return this;
        }
        remove() {
          const _canvas = this.getNativeCanvasElement();
          Node.prototype.remove.call(this);
          if (_canvas && _canvas.parentNode && Util._isInDocument(_canvas)) {
            _canvas.parentNode.removeChild(_canvas);
          }
          return this;
        }
        getStage() {
          return this.parent;
        }
        setSize({ width, height }) {
          this.canvas.setSize(width, height);
          this.hitCanvas.setSize(width, height);
          this._setSmoothEnabled();
          return this;
        }
        _validateAdd(child) {
          const type = child.getType();
          if (type !== "Group" && type !== "Shape") {
            Util.throw("You may only add groups and shapes to a layer.");
          }
        }
        _toKonvaCanvas(config) {
          config = config || {};
          config.width = config.width || this.getWidth();
          config.height = config.height || this.getHeight();
          config.x = config.x !== void 0 ? config.x : this.x();
          config.y = config.y !== void 0 ? config.y : this.y();
          return Node.prototype._toKonvaCanvas.call(this, config);
        }
        _checkVisibility() {
          const visible = this.visible();
          if (visible) {
            this.canvas._canvas.style.display = "block";
          } else {
            this.canvas._canvas.style.display = "none";
          }
        }
        _setSmoothEnabled() {
          this.getContext()._context.imageSmoothingEnabled = this.imageSmoothingEnabled();
        }
        getWidth() {
          if (this.parent) {
            return this.parent.width();
          }
        }
        setWidth() {
          Util.warn('Can not change width of layer. Use "stage.width(value)" function instead.');
        }
        getHeight() {
          if (this.parent) {
            return this.parent.height();
          }
        }
        setHeight() {
          Util.warn('Can not change height of layer. Use "stage.height(value)" function instead.');
        }
        batchDraw() {
          if (!this._waitingForDraw) {
            this._waitingForDraw = true;
            Util.requestAnimFrame(() => {
              this.draw();
              this._waitingForDraw = false;
            });
          }
          return this;
        }
        getIntersection(pos) {
          if (!this.isListening() || !this.isVisible()) {
            return null;
          }
          let spiralSearchDistance = 1;
          let continueSearch = false;
          while (true) {
            for (let i = 0; i < INTERSECTION_OFFSETS_LEN; i++) {
              const intersectionOffset = INTERSECTION_OFFSETS[i];
              const obj = this._getIntersection({
                x: pos.x + intersectionOffset.x * spiralSearchDistance,
                y: pos.y + intersectionOffset.y * spiralSearchDistance
              });
              const shape = obj.shape;
              if (shape) {
                return shape;
              }
              continueSearch = !!obj.antialiased;
              if (!obj.antialiased) {
                break;
              }
            }
            if (continueSearch) {
              spiralSearchDistance += 1;
            } else {
              return null;
            }
          }
        }
        _getIntersection(pos) {
          const ratio = this.hitCanvas.pixelRatio;
          const p = this.hitCanvas.context.getImageData(Math.round(pos.x * ratio), Math.round(pos.y * ratio), 1, 1).data;
          const p3 = p[3];
          if (p3 === 255) {
            const colorKey = Util._rgbToHex(p[0], p[1], p[2]);
            const shape = shapes[HASH + colorKey];
            if (shape) {
              return {
                shape
              };
            }
            return {
              antialiased: true
            };
          } else if (p3 > 0) {
            return {
              antialiased: true
            };
          }
          return {};
        }
        drawScene(can, top, bufferCanvas) {
          const layer = this.getLayer(), canvas = can || layer && layer.getCanvas();
          this._fire(BEFORE_DRAW, {
            node: this
          });
          if (this.clearBeforeDraw()) {
            canvas.getContext().clear();
          }
          Container.prototype.drawScene.call(this, canvas, top, bufferCanvas);
          this._fire(DRAW, {
            node: this
          });
          return this;
        }
        drawHit(can, top) {
          const layer = this.getLayer(), canvas = can || layer && layer.hitCanvas;
          if (layer && layer.clearBeforeDraw()) {
            layer.getHitCanvas().getContext().clear();
          }
          Container.prototype.drawHit.call(this, canvas, top);
          return this;
        }
        enableHitGraph() {
          this.hitGraphEnabled(true);
          return this;
        }
        disableHitGraph() {
          this.hitGraphEnabled(false);
          return this;
        }
        setHitGraphEnabled(val) {
          Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
          this.listening(val);
        }
        getHitGraphEnabled(val) {
          Util.warn("hitGraphEnabled method is deprecated. Please use layer.listening() instead.");
          return this.listening();
        }
        toggleHitCanvas() {
          if (!this.parent || !this.parent["content"]) {
            return;
          }
          const parent = this.parent;
          const added = !!this.hitCanvas._canvas.parentNode;
          if (added) {
            parent.content.removeChild(this.hitCanvas._canvas);
          } else {
            parent.content.appendChild(this.hitCanvas._canvas);
          }
        }
        destroy() {
          Util.releaseCanvas(this.getNativeCanvasElement(), this.getHitCanvas()._canvas);
          return super.destroy();
        }
      }
      Layer.prototype.nodeType = "Layer";
      _registerNode(Layer);
      Factory.addGetterSetter(Layer, "imageSmoothingEnabled", true);
      Factory.addGetterSetter(Layer, "clearBeforeDraw", true);
      Factory.addGetterSetter(Layer, "hitGraphEnabled", true, getBooleanValidator());
      let Image$1 = class Image2 extends Shape {
        constructor(attrs) {
          super(attrs);
          this._loadListener = () => {
            this._requestDraw();
          };
          this.on("imageChange.konva", (props) => {
            this._removeImageLoad(props.oldVal);
            this._setImageLoad();
          });
          this._setImageLoad();
        }
        _setImageLoad() {
          const image = this.image();
          if (image && image.complete) {
            return;
          }
          if (image && image.readyState === 4) {
            return;
          }
          if (image && image["addEventListener"]) {
            image["addEventListener"]("load", this._loadListener);
          }
        }
        _removeImageLoad(image) {
          if (image && image["removeEventListener"]) {
            image["removeEventListener"]("load", this._loadListener);
          }
        }
        destroy() {
          this._removeImageLoad(this.image());
          super.destroy();
          return this;
        }
        _useBufferCanvas() {
          const hasCornerRadius = !!this.cornerRadius();
          const hasShadow = this.hasShadow();
          if (hasCornerRadius && hasShadow) {
            return true;
          }
          return super._useBufferCanvas(true);
        }
        _sceneFunc(context) {
          const width = this.getWidth();
          const height = this.getHeight();
          const cornerRadius = this.cornerRadius();
          const image = this.attrs.image;
          let params;
          if (image) {
            const cropWidth = this.attrs.cropWidth;
            const cropHeight = this.attrs.cropHeight;
            if (cropWidth && cropHeight) {
              params = [
                image,
                this.cropX(),
                this.cropY(),
                cropWidth,
                cropHeight,
                0,
                0,
                width,
                height
              ];
            } else {
              params = [image, 0, 0, width, height];
            }
          }
          if (this.hasFill() || this.hasStroke() || cornerRadius) {
            context.beginPath();
            cornerRadius ? Util.drawRoundedRectPath(context, width, height, cornerRadius) : context.rect(0, 0, width, height);
            context.closePath();
            context.fillStrokeShape(this);
          }
          if (image) {
            if (cornerRadius) {
              context.clip();
            }
            context.drawImage.apply(context, params);
          }
        }
        _hitFunc(context) {
          const width = this.width(), height = this.height(), cornerRadius = this.cornerRadius();
          context.beginPath();
          if (!cornerRadius) {
            context.rect(0, 0, width, height);
          } else {
            Util.drawRoundedRectPath(context, width, height, cornerRadius);
          }
          context.closePath();
          context.fillStrokeShape(this);
        }
        getWidth() {
          var _a, _b;
          return (_a = this.attrs.width) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.width;
        }
        getHeight() {
          var _a, _b;
          return (_a = this.attrs.height) !== null && _a !== void 0 ? _a : (_b = this.image()) === null || _b === void 0 ? void 0 : _b.height;
        }
        static fromURL(url, callback, onError = null) {
          const img = Util.createImageElement();
          img.onload = function() {
            const image = new Image2({
              image: img
            });
            callback(image);
          };
          img.onerror = onError;
          img.crossOrigin = "Anonymous";
          img.src = url;
        }
      };
      Image$1.prototype.className = "Image";
      _registerNode(Image$1);
      Factory.addGetterSetter(Image$1, "cornerRadius", 0, getNumberOrArrayOfNumbersValidator(4));
      Factory.addGetterSetter(Image$1, "image");
      Factory.addComponentsGetterSetter(Image$1, "crop", ["x", "y", "width", "height"]);
      Factory.addGetterSetter(Image$1, "cropX", 0, getNumberValidator());
      Factory.addGetterSetter(Image$1, "cropY", 0, getNumberValidator());
      Factory.addGetterSetter(Image$1, "cropWidth", 0, getNumberValidator());
      Factory.addGetterSetter(Image$1, "cropHeight", 0, getNumberValidator());
      const now = function() {
        if (glob.performance && glob.performance.now) {
          return function() {
            return glob.performance.now();
          };
        }
        return function() {
          return (/* @__PURE__ */ new Date()).getTime();
        };
      }();
      class Animation {
        constructor(func, layers) {
          this.id = Animation.animIdCounter++;
          this.frame = {
            time: 0,
            timeDiff: 0,
            lastTime: now(),
            frameRate: 0
          };
          this.func = func;
          this.setLayers(layers);
        }
        setLayers(layers) {
          let lays = [];
          if (layers) {
            lays = Array.isArray(layers) ? layers : [layers];
          }
          this.layers = lays;
          return this;
        }
        getLayers() {
          return this.layers;
        }
        addLayer(layer) {
          const layers = this.layers;
          const len = layers.length;
          for (let n = 0; n < len; n++) {
            if (layers[n]._id === layer._id) {
              return false;
            }
          }
          this.layers.push(layer);
          return true;
        }
        isRunning() {
          const a = Animation;
          const animations = a.animations;
          const len = animations.length;
          for (let n = 0; n < len; n++) {
            if (animations[n].id === this.id) {
              return true;
            }
          }
          return false;
        }
        start() {
          this.stop();
          this.frame.timeDiff = 0;
          this.frame.lastTime = now();
          Animation._addAnimation(this);
          return this;
        }
        stop() {
          Animation._removeAnimation(this);
          return this;
        }
        _updateFrameObject(time) {
          this.frame.timeDiff = time - this.frame.lastTime;
          this.frame.lastTime = time;
          this.frame.time += this.frame.timeDiff;
          this.frame.frameRate = 1e3 / this.frame.timeDiff;
        }
        static _addAnimation(anim) {
          this.animations.push(anim);
          this._handleAnimation();
        }
        static _removeAnimation(anim) {
          const id = anim.id;
          const animations = this.animations;
          const len = animations.length;
          for (let n = 0; n < len; n++) {
            if (animations[n].id === id) {
              this.animations.splice(n, 1);
              break;
            }
          }
        }
        static _runFrames() {
          const layerHash = {};
          const animations = this.animations;
          for (let n = 0; n < animations.length; n++) {
            const anim = animations[n];
            const layers = anim.layers;
            const func = anim.func;
            anim._updateFrameObject(now());
            const layersLen = layers.length;
            let needRedraw;
            if (func) {
              needRedraw = func.call(anim, anim.frame) !== false;
            } else {
              needRedraw = true;
            }
            if (!needRedraw) {
              continue;
            }
            for (let i = 0; i < layersLen; i++) {
              const layer = layers[i];
              if (layer._id !== void 0) {
                layerHash[layer._id] = layer;
              }
            }
          }
          for (const key in layerHash) {
            if (!layerHash.hasOwnProperty(key)) {
              continue;
            }
            layerHash[key].batchDraw();
          }
        }
        static _animationLoop() {
          const Anim = Animation;
          if (Anim.animations.length) {
            Anim._runFrames();
            Util.requestAnimFrame(Anim._animationLoop);
          } else {
            Anim.animRunning = false;
          }
        }
        static _handleAnimation() {
          if (!this.animRunning) {
            this.animRunning = true;
            Util.requestAnimFrame(this._animationLoop);
          }
        }
      }
      Animation.animations = [];
      Animation.animIdCounter = 0;
      Animation.animRunning = false;
      const blacklist = {
        node: 1,
        duration: 1,
        easing: 1,
        onFinish: 1,
        yoyo: 1
      }, PAUSED = 1, PLAYING = 2, REVERSING = 3, colorAttrs = ["fill", "stroke", "shadowColor"];
      let idCounter = 0;
      class TweenEngine {
        constructor(prop, propFunc, func, begin, finish, duration, yoyo) {
          this.prop = prop;
          this.propFunc = propFunc;
          this.begin = begin;
          this._pos = begin;
          this.duration = duration;
          this._change = 0;
          this.prevPos = 0;
          this.yoyo = yoyo;
          this._time = 0;
          this._position = 0;
          this._startTime = 0;
          this._finish = 0;
          this.func = func;
          this._change = finish - this.begin;
          this.pause();
        }
        fire(str) {
          const handler = this[str];
          if (handler) {
            handler();
          }
        }
        setTime(t) {
          if (t > this.duration) {
            if (this.yoyo) {
              this._time = this.duration;
              this.reverse();
            } else {
              this.finish();
            }
          } else if (t < 0) {
            if (this.yoyo) {
              this._time = 0;
              this.play();
            } else {
              this.reset();
            }
          } else {
            this._time = t;
            this.update();
          }
        }
        getTime() {
          return this._time;
        }
        setPosition(p) {
          this.prevPos = this._pos;
          this.propFunc(p);
          this._pos = p;
        }
        getPosition(t) {
          if (t === void 0) {
            t = this._time;
          }
          return this.func(t, this.begin, this._change, this.duration);
        }
        play() {
          this.state = PLAYING;
          this._startTime = this.getTimer() - this._time;
          this.onEnterFrame();
          this.fire("onPlay");
        }
        reverse() {
          this.state = REVERSING;
          this._time = this.duration - this._time;
          this._startTime = this.getTimer() - this._time;
          this.onEnterFrame();
          this.fire("onReverse");
        }
        seek(t) {
          this.pause();
          this._time = t;
          this.update();
          this.fire("onSeek");
        }
        reset() {
          this.pause();
          this._time = 0;
          this.update();
          this.fire("onReset");
        }
        finish() {
          this.pause();
          this._time = this.duration;
          this.update();
          this.fire("onFinish");
        }
        update() {
          this.setPosition(this.getPosition(this._time));
          this.fire("onUpdate");
        }
        onEnterFrame() {
          const t = this.getTimer() - this._startTime;
          if (this.state === PLAYING) {
            this.setTime(t);
          } else if (this.state === REVERSING) {
            this.setTime(this.duration - t);
          }
        }
        pause() {
          this.state = PAUSED;
          this.fire("onPause");
        }
        getTimer() {
          return (/* @__PURE__ */ new Date()).getTime();
        }
      }
      class Tween {
        constructor(config) {
          const that = this, node = config.node, nodeId = node._id, easing = config.easing || Easings.Linear, yoyo = !!config.yoyo;
          let duration, key;
          if (typeof config.duration === "undefined") {
            duration = 0.3;
          } else if (config.duration === 0) {
            duration = 1e-3;
          } else {
            duration = config.duration;
          }
          this.node = node;
          this._id = idCounter++;
          const layers = node.getLayer() || (node instanceof Konva["Stage"] ? node.getLayers() : null);
          if (!layers) {
            Util.error("Tween constructor have `node` that is not in a layer. Please add node into layer first.");
          }
          this.anim = new Animation(function() {
            that.tween.onEnterFrame();
          }, layers);
          this.tween = new TweenEngine(key, function(i) {
            that._tweenFunc(i);
          }, easing, 0, 1, duration * 1e3, yoyo);
          this._addListeners();
          if (!Tween.attrs[nodeId]) {
            Tween.attrs[nodeId] = {};
          }
          if (!Tween.attrs[nodeId][this._id]) {
            Tween.attrs[nodeId][this._id] = {};
          }
          if (!Tween.tweens[nodeId]) {
            Tween.tweens[nodeId] = {};
          }
          for (key in config) {
            if (blacklist[key] === void 0) {
              this._addAttr(key, config[key]);
            }
          }
          this.reset();
          this.onFinish = config.onFinish;
          this.onReset = config.onReset;
          this.onUpdate = config.onUpdate;
        }
        _addAttr(key, end) {
          const node = this.node, nodeId = node._id;
          let diff, len, trueEnd, trueStart, endRGBA;
          const tweenId = Tween.tweens[nodeId][key];
          if (tweenId) {
            delete Tween.attrs[nodeId][tweenId][key];
          }
          let start = node.getAttr(key);
          if (Util._isArray(end)) {
            diff = [];
            len = Math.max(end.length, start.length);
            if (key === "points" && end.length !== start.length) {
              if (end.length > start.length) {
                trueStart = start;
                start = Util._prepareArrayForTween(start, end, node.closed());
              } else {
                trueEnd = end;
                end = Util._prepareArrayForTween(end, start, node.closed());
              }
            }
            if (key.indexOf("fill") === 0) {
              for (let n = 0; n < len; n++) {
                if (n % 2 === 0) {
                  diff.push(end[n] - start[n]);
                } else {
                  const startRGBA = Util.colorToRGBA(start[n]);
                  endRGBA = Util.colorToRGBA(end[n]);
                  start[n] = startRGBA;
                  diff.push({
                    r: endRGBA.r - startRGBA.r,
                    g: endRGBA.g - startRGBA.g,
                    b: endRGBA.b - startRGBA.b,
                    a: endRGBA.a - startRGBA.a
                  });
                }
              }
            } else {
              for (let n = 0; n < len; n++) {
                diff.push(end[n] - start[n]);
              }
            }
          } else if (colorAttrs.indexOf(key) !== -1) {
            start = Util.colorToRGBA(start);
            endRGBA = Util.colorToRGBA(end);
            diff = {
              r: endRGBA.r - start.r,
              g: endRGBA.g - start.g,
              b: endRGBA.b - start.b,
              a: endRGBA.a - start.a
            };
          } else {
            diff = end - start;
          }
          Tween.attrs[nodeId][this._id][key] = {
            start,
            diff,
            end,
            trueEnd,
            trueStart
          };
          Tween.tweens[nodeId][key] = this._id;
        }
        _tweenFunc(i) {
          const node = this.node, attrs = Tween.attrs[node._id][this._id];
          let key, attr, start, diff, newVal, n, len, end;
          for (key in attrs) {
            attr = attrs[key];
            start = attr.start;
            diff = attr.diff;
            end = attr.end;
            if (Util._isArray(start)) {
              newVal = [];
              len = Math.max(start.length, end.length);
              if (key.indexOf("fill") === 0) {
                for (n = 0; n < len; n++) {
                  if (n % 2 === 0) {
                    newVal.push((start[n] || 0) + diff[n] * i);
                  } else {
                    newVal.push("rgba(" + Math.round(start[n].r + diff[n].r * i) + "," + Math.round(start[n].g + diff[n].g * i) + "," + Math.round(start[n].b + diff[n].b * i) + "," + (start[n].a + diff[n].a * i) + ")");
                  }
                }
              } else {
                for (n = 0; n < len; n++) {
                  newVal.push((start[n] || 0) + diff[n] * i);
                }
              }
            } else if (colorAttrs.indexOf(key) !== -1) {
              newVal = "rgba(" + Math.round(start.r + diff.r * i) + "," + Math.round(start.g + diff.g * i) + "," + Math.round(start.b + diff.b * i) + "," + (start.a + diff.a * i) + ")";
            } else {
              newVal = start + diff * i;
            }
            node.setAttr(key, newVal);
          }
        }
        _addListeners() {
          this.tween.onPlay = () => {
            this.anim.start();
          };
          this.tween.onReverse = () => {
            this.anim.start();
          };
          this.tween.onPause = () => {
            this.anim.stop();
          };
          this.tween.onFinish = () => {
            const node = this.node;
            const attrs = Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueEnd) {
              node.setAttr("points", attrs.points.trueEnd);
            }
            if (this.onFinish) {
              this.onFinish.call(this);
            }
          };
          this.tween.onReset = () => {
            const node = this.node;
            const attrs = Tween.attrs[node._id][this._id];
            if (attrs.points && attrs.points.trueStart) {
              node.points(attrs.points.trueStart);
            }
            if (this.onReset) {
              this.onReset();
            }
          };
          this.tween.onUpdate = () => {
            if (this.onUpdate) {
              this.onUpdate.call(this);
            }
          };
        }
        play() {
          this.tween.play();
          return this;
        }
        reverse() {
          this.tween.reverse();
          return this;
        }
        reset() {
          this.tween.reset();
          return this;
        }
        seek(t) {
          this.tween.seek(t * 1e3);
          return this;
        }
        pause() {
          this.tween.pause();
          return this;
        }
        finish() {
          this.tween.finish();
          return this;
        }
        destroy() {
          const nodeId = this.node._id, thisId = this._id, attrs = Tween.tweens[nodeId];
          this.pause();
          if (this.anim) {
            this.anim.stop();
          }
          for (const key in attrs) {
            delete Tween.tweens[nodeId][key];
          }
          delete Tween.attrs[nodeId][thisId];
          if (Tween.tweens[nodeId]) {
            if (Object.keys(Tween.tweens[nodeId]).length === 0) {
              delete Tween.tweens[nodeId];
            }
            if (Object.keys(Tween.attrs[nodeId]).length === 0) {
              delete Tween.attrs[nodeId];
            }
          }
        }
      }
      Tween.attrs = {};
      Tween.tweens = {};
      Node.prototype.to = function(params) {
        const onFinish = params.onFinish;
        params.node = this;
        params.onFinish = function() {
          this.destroy();
          if (onFinish) {
            onFinish();
          }
        };
        const tween = new Tween(params);
        tween.play();
      };
      const Easings = {
        BackEaseOut(t, b, c, d) {
          const s = 1.70158;
          return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
        },
        Linear(t, b, c, d) {
          return c * t / d + b;
        }
      };
      const sall = (fn) => fn();
      const DEFAULT_R = 15;
      const checkIsMobile = () => {
        return window.matchMedia("(max-width: 767px)").matches;
      };
      class ArnoldiIter2D {
        constructor(seedX = Math.random(), seedY = Math.random(), R = DEFAULT_R) {
          /** 取值 0-1 */
          __publicField(this, "x");
          /** 取值 0-1 */
          __publicField(this, "y");
          __publicField(this, "R");
          this.x = seedX;
          this.y = seedY;
          this.R = R;
        }
        next() {
          const {
            R
          } = this;
          const nx = (this.x + this.y) % 1;
          const ny = (this.x + 2 * this.y) % 1;
          this.x = nx;
          this.y = ny;
          return {
            dx: Math.round(nx * 2 * R) - R,
            dy: Math.round(ny * 2 * R) - R
          };
        }
      }
      function initChaoticEffect(params) {
        const payload = params.payload;
        const container = document.querySelector(payload.container);
        if (!container) return;
        if (checkIsMobile()) {
          let cb = function() {
            if (!checkIsMobile()) {
              window.removeEventListener("resize", cb);
              initChaoticEffect(params);
            }
          };
          return window.addEventListener("resize", cb);
        }
        const DEFAULT_SCALE = 0.6;
        const MAX_WIDTH = 1920;
        const MAX_HEIGHT = 630;
        const stage = new Stage({
          container,
          width: Math.min(MAX_WIDTH, container.clientWidth),
          height: Math.min(MAX_HEIGHT, container.clientHeight)
        });
        stage.content.classList.remove("konvajs-content");
        stage.content.classList.add("elegoo-canvas-content");
        const layer = new Layer();
        sall(() => {
          let img = null;
          if (/https:\/\//.test(payload.spritesheet) || /^\/\//.test(payload.spritesheet)) {
            img = new Image();
            img.crossOrigin = "anonymous";
            img.src = payload.spritesheet;
          } else {
            img = document.querySelector(payload.spritesheet);
          }
          if (!img) {
            const msg = "[Chaotic Hero]: spritesheet not found";
            console.error(msg, payload.spritesheet);
            throw new Error(msg);
          }
          const canvas = document.createElement("canvas");
          const sheets = [{
            name: "CO",
            x: 0,
            y: 0,
            width: 620,
            height: 400,
            listening: true,
            pos: {
              x: 280,
              y: 230
            }
          }, {
            name: "T",
            x: 930,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            zIndex: 0,
            pos: {
              x: 920,
              y: 230
            }
          }, {
            name: "N",
            x: 620,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            zIndex: 100,
            pos: {
              x: 675,
              y: 230
            }
          }, {
            name: "C",
            x: 1550,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            zIndex: 0,
            pos: {
              x: 1330,
              y: 230
            }
          }, {
            name: "A",
            x: 1240,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            zIndex: 10,
            pos: {
              x: 1135,
              y: 230
            }
          }, {
            name: "T",
            x: 1860,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            zIndex: 0,
            pos: {
              x: 1530,
              y: 250
            }
          }, {
            name: "label",
            x: 2170,
            y: 0,
            width: 352,
            height: 400,
            pos: {
              x: 1505,
              y: 560
            }
          }, {
            name: "label 2",
            x: 2522,
            y: 0,
            width: 310,
            height: 400,
            pos: {
              x: 105,
              y: 580
            }
          }, {
            name: "LOGO",
            x: 2832,
            y: 0,
            width: 310,
            height: 400,
            pos: {
              x: 375,
              y: 560
            }
          }, {
            name: "U",
            x: 3142,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            pos: {
              x: 740,
              y: 570
            }
          }, {
            name: "S",
            x: 3452,
            y: 0,
            width: 310,
            height: 400,
            listening: true,
            pos: {
              x: 1015,
              y: 565
            }
          }, {
            name: "arrow",
            x: 3762,
            y: 0,
            width: 310,
            height: 400,
            pos: {
              x: 1280,
              y: 560
            }
          }, {
            name: "star green",
            x: 4072,
            y: 0,
            width: 310,
            height: 400,
            pos: {
              x: 160,
              y: 495
            }
          }, {
            name: "star yellow",
            x: 4382,
            y: 0,
            width: 310,
            height: 400,
            pos: {
              x: 1435,
              y: 500
            }
          }];
          return new Promise(async (resolve) => {
            await new Promise((r) => {
              if (img.complete) r();
              img.onload = () => {
                r();
              };
            });
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            resolve(sheets.map((v) => {
              var _a, _b;
              const offscreen = document.createElement("canvas");
              offscreen.width = v.width;
              offscreen.height = v.height;
              const offscreenCtx = offscreen.getContext("2d");
              offscreenCtx.drawImage(canvas, v.x, v.y, v.width, v.height, 0, 0, v.width, v.height);
              return new Image$1({
                image: offscreen,
                width: v.width,
                height: v.height,
                x: ((_a = v.pos) == null ? void 0 : _a.x) ?? 0,
                y: ((_b = v.pos) == null ? void 0 : _b.y) ?? 0,
                listening: v.listening ?? false,
                offset: {
                  x: v.width / 2,
                  y: v.height / 2
                }
              });
            }));
          });
        }).then((sprites) => {
          if (!stage) return;
          const textGroup = new Group();
          textGroup.add(...sprites);
          for (let sprite of sprites) {
            let isProcessing = false;
            let task = [];
            sprite.addEventListener("mouseover", () => {
              if (isProcessing) return;
              sprite.to({
                scaleX: 1.07,
                scaleY: 1.07,
                duration: 0.3,
                easing: Easings.BackEaseOut,
                onUpate() {
                  isProcessing = true;
                },
                onFinish() {
                  const fn = task == null ? void 0 : task.shift();
                  if (typeof fn === "function") fn();
                }
              });
            });
            let isTainted = false;
            try {
              if (!isTainted) {
                sprite.cache();
                sprite.drawHitFromCache(0);
              }
            } catch (err) {
              isTainted = true;
              console.error(err);
            }
            sprite.addEventListener("mouseout", () => {
              const cb = () => {
                sprite.to({
                  scaleX: 1,
                  scaleY: 1,
                  duration: 0.3,
                  easing: Easings.BackEaseOut
                });
              };
              if (isProcessing) {
                task = [cb];
              } else {
                cb();
              }
            });
          }
          const clientRect = textGroup.getClientRect();
          textGroup.offset({
            x: clientRect.width / 2,
            y: clientRect.height / 2
          }).setAttrs({
            x: stage.width() / 2,
            y: stage.height() / 2,
            scaleX: DEFAULT_SCALE,
            scaleY: DEFAULT_SCALE
          });
          layer.add(textGroup);
          const layerChildren = textGroup.children;
          layerChildren.forEach((node) => {
            const basePosition = {
              x: node.x(),
              y: node.y()
            };
            const arnoldNode = new ArnoldiIter2D();
            const tick = () => {
              const idle = 1.5 + Math.random() * 2;
              const {
                dx,
                dy
              } = arnoldNode.next();
              node.to({
                x: basePosition.x + dx,
                y: basePosition.y + dy,
                rotation: dx / 2 + dy / 2,
                duration: idle,
                easing: Easings.Linear,
                onFinish: () => {
                  requestAnimationFrame(tick);
                }
              });
            };
            requestAnimationFrame(tick);
          });
          window.addEventListener("resize", () => {
            if (checkIsMobile()) {
              if (stage.isVisible()) {
                stage.hide();
              }
            } else {
              stage.show();
              let offsetX = -80;
              stage.width(Math.min(1920, container.clientWidth));
              stage.height(Math.min(630, container.clientHeight));
              textGroup.setAttrs({
                x: stage.width() / 2 + offsetX,
                y: stage.height() / 2
              });
            }
          });
        });
        stage.add(layer);
      }
    }
  };
});
